<template>
<div>
    <v-dialog v-model="dialog.dialogProgress" persistent width="300" eager>
      <v-card color="primary" dark>
        <v-card-text>
          {{progressMessage}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogUpload" persistent width="300" eager>
      <v-card color="primary" dark>
        <v-card-text>
          {{progressMessage}}
          <v-progress-circular
            :rotate="-90"
            :size="100"
            :width="15"
            :value="uploadPercentage"
            color="white"
          >
            {{uploadPercentage}}
          </v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogpdfShow" scrollable max-width="900px" fullscreen persistent>
    <v-card flat>
      <v-card-title>
        
        <v-toolbar dense flat scrollable color="white">
          <v-toolbar-title class="primary--text">Report</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-divider class="mx-1" inset vertical></v-divider>
          <!-- <v-btn outlined color="primary" style="text-transform: capitalize" @click="pathoPdf('Y', 'D')" :disabled="disabledControl.buttonSave">
            <img src="../assets/SoftwareClinicIcon/Adobe-PDF-Document-icon.png" height="30" weight="30"/>Download
          </v-btn> -->
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" style="text-transform: capitalize" @click="closeDialogpdfShow">
            <img src="../assets/SoftwareClinicIcon/close-icon.png" height="30" weight="30"/>Close
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <iframe :src="pdfShow"
        type="application/pdf" style="overflow: auto; width: 100%; height: 100%;">
        </iframe>
      </v-card-text>
    </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogviewRemark" max-width="1000px" eager>
      <v-card>
        <v-card-title>
          <span class="headline">{{$t('WpLabRequest.remark')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field class="ma-0 pa-0" hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('WpLabRequest.remark')"
                  v-model="itemRemark"
                  rows="4"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn outlined color="error" @click="closeViewRemark()">{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogStatusHist" scrollable max-width="900px">
      <v-card flat>
        <v-card-title>
          <v-toolbar dense flat scrollable color="white">
            <v-toolbar-title class="primary--text">History</v-toolbar-title>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-data-table
            v-model="vDataTableStatusHist.selected"
            :headers="statusHistheaders"
            :items="vDataTableStatusHist.data"
            :search="vDataTableStatusHist.search"
            fixed-header
            :page.sync="vDataTableStatusHist.options.page"
            :itemsPerPage.sync="vDataTableStatusHist.options.itemsPerPage"
            :options.sync="vDataTableStatusHist.options"
            :height="$vuetify.breakpoint.height - 160 - offsetAppBar"
            :footer-props="{
              itemsPerPageText: $t('itemsPerPageText'),
              itemsPerPageAllText: $t('itemsPerPageAllText'),
              showFirstLastPage: true,
              showCurrentPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
            item-key="row"
            class="fill-height">            
            <template v-slot:[`item.date_created`]="{ item }">
              <span>{{ formatDateTimeDisplay(item.date_created) }}</span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              {{ getHistStatusName(item.status) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-data-table
      v-model="vDataTable.selected"
      :headers="headers"
      :items="vDataTable.data"
      :search="vDataTable.search"
      fixed-header
      :page.sync="vDataTable.options.page"
      :itemsPerPage.sync="vDataTable.options.itemsPerPage"
      :options.sync="vDataTable.options"
      :height="$vuetify.breakpoint.height - 340 - offsetAppBar"
      show-select
      :footer-props="{
        itemsPerPageText: $t('itemsPerPageText'),
        itemsPerPageAllText: $t('itemsPerPageAllText'),
        showFirstLastPage: true,
        showCurrentPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
      item-key="specimen_type_id"
      class="fill-height mt-5">

      <!-- <template v-slot:[`header.data-table-select`]="{ on, props }">
        <tr>
          <td>
            <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
          </td>
          <td v-if="vDataTable.selected.length > 0">
            {{vDataTable.selected.length}}
          </td>
        </tr>
      </template> -->
      <template v-slot:[`item.status`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-if="item.status == 'WpLabReceive.statusObj.OP'" large color="green" v-bind="attrs" v-on="on">
              mdi-check-circle
            </v-icon>
            <v-icon v-else-if="item.status == 'WpLabReceive.statusObj.receivedReject'" large color="green" v-bind="attrs" v-on="on">
              mdi-circle-slice-8
            </v-icon>
            <v-icon v-else-if="item.status == 'WpLabReceive.statusObj.receivedRejectSome'" large color="yellow" v-bind="attrs" v-on="on">
              mdi-circle-slice-8
            </v-icon>
            <v-icon v-else-if="item.status == 'WpLabReceive.statusObj.rejected'" large color="red" v-bind="attrs" v-on="on">
              mdi-alert-circle
            </v-icon>
          </template>
          <span>{{ item.status }}</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.date_created`]="{ item }">
        <span>{{ formatDateTimeDisplay(item.date_created) }}</span>
      </template>
      <template v-slot:[`item.date_send`]="{ item }">
        <span>{{ formatDateTimeDisplay(item.date_send) }}</span>
      </template>
      <template v-slot:[`item.date_receive`]="{ item }">
        <span>{{ formatDateTimeDisplay(item.date_receive) }}</span>
      </template>
      <template v-slot:[`item.date_result`]="{ item }">
        <span>{{ formatDateTimeDisplay(item.date_result) }}</span>
      </template>
      <template v-slot:top>
        <v-card flat width="100%" heigth="100%">
      <v-card-title>
        <v-row>
                <v-col >
                  <span class="headline" ><h6 style="color: #003057;" > {{$t('WpLabReceive.receiveLab')}}</h6></span>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="3">
                  
                  <v-text-field
                    class="mb-3 mt-3"
                    v-model="vDataTable.search"
                    append-icon="mdi-magnify"
                    :label="$t('WpLabReceive.search')"
                    single-line
                    hide-details
                    outlined
                    dense
                    >
                  </v-text-field>
                </v-col>
            </v-row>
       
      </v-card-title>
      <v-row dense flat>
        <v-col cols="3" sm="3" md="3" lg="3" class="ml-12">
          <div class="">
            <v-dialog
                  ref="dialogReceivedDateFromTo"
                  v-model="dialog.dialogReceivedDateFromTo"
                  :return-value.sync="criteria.ReceivedDateFromTo"
                  persistent
                  width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                      style="position: absolute;"
                      dense
                        hide-details
                        width="24%"
                        v-model="dateRangeText"
                        prepend-icon="mdi-calendar"
                        readonly
                        color="#003057"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon color="#FFF" class="mr-1">mdi-calendar</v-icon> 
                        <span class="no-wrap-text">
                          {{ $t('WpLabReceive.date_created') }} {{ dateRangeText }}
                        </span>
                      </v-btn>

                    <!-- <v-text-field dense
                      hide-details
                      outlined
                      v-model="dateRangeText"
                      :label="$t('WpLabReceive.date_created')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"></v-text-field> -->
                  </template>
                  <v-date-picker
                    v-model="criteria.ReceivedDateFromTo"
                    :selected-items-text="selectDate"
                    locale="th-th"
                    range
                    scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dialog.dialogReceivedDateFromTo = false">{{$t('cancel')}}</v-btn>
                    <v-btn text color="primary" @click="$refs.dialogReceivedDateFromTo.save(criteria.ReceivedDateFromTo)">{{$t('ok')}}</v-btn>
                  </v-date-picker>
                </v-dialog>
                 
          </div>
        
            
        </v-col >

        <v-col cols="2" lg="2" sm="12" md="2">
          <v-btn 
          outlined 
          color="primary" 
          style="text-transform: capitalize" 
          @click="checkResentGateway()"
          width="100%"
          >
          Resent
                  <!-- <img src="../assets/SoftwareClinicIcon/Find.png" height="30" weight="60"/>{{$t('Resent')}} -->
                </v-btn>
        </v-col>

        <v-col cols="2" lg="2" sm="12" md="2">
          <v-btn
            
           color="primary" 
           style="text-transform: capitalize"
           width="100%"
            @click="checkPrintRequestSelected()">
            <v-icon class="mr-2">mdi-printer-outline</v-icon>
            {{$t('WpLabReceive.printOrderReport')}}
                  <!-- <img src="../assets/IconAction/Preprint.png" height="30" weight="60"/>{{$t('WpLabReceive.printOrderReport')}} -->
          </v-btn>
          <!-- <v-text-field outlined dense hide-details v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>  -->
        </v-col>

        <!-- ปุ่มรับสิ่งส่งตรวจ -->
        <v-col cols="2" lg="2" sm="12" md="2">
          <v-btn
            class="icon-button"
            @click="receiveSpecimenMSSQL"
            color="#04AB2F"
            width="100%"
          >
            <v-icon class="mr-2">mdi-file-check-outline</v-icon>
            <span class="font-weight-bold">{{ $t('WpLabReceive.receiveLab') }}</span>
          </v-btn>
        </v-col>
        
        <v-col cols="2" lg="2" sm="12" md="2">
          <v-btn 
          outlined 
          color="primary" 
          style="text-transform: capitalize" 
          @click="clearData()"
          width="100%"
          >
          <v-icon >
            mdi-refresh
          </v-icon>
          {{$t('clear')}}
                  <!-- <img src="../assets/SoftwareClinicIcon/trash.png" height="30" weight="60"/>{{$t('clear')}} -->
            </v-btn>
        </v-col>


      </v-row>
      <v-row dense flat justifly="start" class="ml-11 mt-2 mb-3">
          <v-col cols="1" sm="1" md="1" lg="1" >
            <v-text-field
              outlined dense hide-details
              :label="$t('WpLabReceive.OrderId')"
              v-model="FindOrderId"
              @keydown.enter="retrieveLabReceive"
            ></v-text-field>
          </v-col>
          <v-col cols="1" sm="1" md="1" lg="1">
            <v-text-field
              outlined dense hide-details
              :label="$t('WpLabReceive.HN')"
              v-model="FindHN"
              @keydown.enter="retrieveLabReceive"
            ></v-text-field>
          </v-col>
          <v-col cols="3" sm="3" md="3" lg="2">
            <v-text-field
              outlined dense hide-details
              :label="$t('WpLabReceive.PatientName')"
              v-model="firstName"
              @keydown.enter="retrieveLabReceive"
            ></v-text-field>
          </v-col>
          <v-col cols="2" sm="2" md="2" lg="2">
                <v-select :items="viewList" v-model="lab_view_skey" item-text="view_desc" item-value="view_skey" clearable
                  :label="$t('WpLabRequest.lablaboratoryName')" persistent-hint single-line outlined dense hide-details
                  @keydown.enter="retrieveLabReceive">
                </v-select>
          </v-col>
          <v-col cols="3" sm="3" md="3" lg="2">
            <v-text-field
              outlined dense hide-details
              :label="$t('WpLabReceive.packageNo')"
              v-model="find_PackageNo"
              @keydown.enter="retrieveLabReceive"
            ></v-text-field>
          </v-col>
          <v-col cols="2" sm="2" md="2" lg="2">
            <v-autocomplete 
            dense 
            hide-details 
            color="#003057"
            width="250px"
            :label="$t('WpLabRequest.status')" 
            :items="statusListAll" 
            v-model="status"
            :item-text="item => $t(item.status_name)"
            item-value="status"
            class="text-center"
            @keydown.enter="retrieveLabReceive"
            clearable
            outlined>
            </v-autocomplete>
          </v-col>
          <v-col cols="2" sm="2" md="5" lg="2">
            <v-btn outlined color="primary" style="text-transform: capitalize" @click="retrieveLabReceive(appName)">
              <v-icon>
                mdi-magnify
              </v-icon>
              <span class="ml-2">
                {{$t('find')}}
              </span>
              
                  <!-- <img src="../assets/SoftwareClinicIcon/Find.png" height="30" weight="60"/>{{$t('find')}} -->
                </v-btn>
          </v-col>
        </v-row>
      </v-card>




        <!-- <v-toolbar height="50%"> -->
          
          <!-- <v-toolbar-title>{{'รับสิ่งส่งตรวจ'}}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider> -->
          <!-- <v-container >
            <v-row dense flat>
              <v-col class="text-right">
                <v-btn outlined color="primary" style="text-transform: capitalize" @click="checkResentGateway()">
                  <img src="../assets/SoftwareClinicIcon/Find.png" height="30" weight="60"/>{{$t('Resent')}}
                </v-btn>                
                <v-divider class="mx-1" inset vertical></v-divider>
                <v-btn outlined color="primary" style="text-transform: capitalize" @click="retrieveLabReceive(appName)">
                  <img src="../assets/SoftwareClinicIcon/Find.png" height="30" weight="60"/>{{$t('find')}}
                </v-btn>
                <v-divider class="mx-1" inset vertical></v-divider>
                <v-btn outlined color="primary" style="text-transform: capitalize" @click="clearData()">
                  <img src="../assets/SoftwareClinicIcon/trash.png" height="30" weight="60"/>{{$t('clear')}}
                </v-btn>
                <v-divider class="mx-1" inset vertical></v-divider>
                <v-btn outlined color="primary" style="text-transform: capitalize" @click="checkPrintRequestSelected()">
                  <img src="../assets/IconAction/Preprint.png" height="30" weight="60"/>{{$t('WpLabReceive.printOrderReport')}}
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense flat>
              <v-col cols="2" sm="2" md="5" lg="2">
                <v-select :items="viewList" v-model="lab_view_skey" item-text="view_desc" item-value="view_skey" clearable
                  :label="$t('WpLabRequest.lablaboratoryName')" persistent-hint single-line outlined dense hide-details>
                </v-select>
              </v-col>
              <v-col cols="2" sm="2" md="2" lg="1">
                <v-text-field
                  outlined dense hide-details
                  :label="$t('WpLabReceive.OrderItemId')"
                  v-model="FindOrderId"
                ></v-text-field>
              </v-col>
              <v-col cols="2" sm="2" md="2" lg="2">
                <v-text-field
                  outlined dense hide-details
                  :label="$t('WpLabReceive.HN')"
                  v-model="FindHN"
                ></v-text-field>
              </v-col>
              <v-col cols="3" sm="3" md="3" lg="3">
                <v-text-field
                  outlined dense hide-details
                  :label="$t('WpLabReceive.PatientName')"
                  v-model="firstName"
                ></v-text-field>
              </v-col>
              <v-col cols="3" sm="3" md="2" lg="2">
                <v-dialog
                  ref="dialogReceivedDateFromTo"
                  v-model="dialog.dialogReceivedDateFromTo"
                  :return-value.sync="criteria.ReceivedDateFromTo"
                  persistent
                  width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field dense
                      hide-details
                      outlined
                      v-model="dateRangeText"
                      :label="$t('WpLabReceive.date_created')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="criteria.ReceivedDateFromTo"
                    :selected-items-text="selectDate"
                    locale="th-th"
                    range
                    scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dialog.dialogReceivedDateFromTo = false">{{$t('cancel')}}</v-btn>
                    <v-btn text color="primary" @click="$refs.dialogReceivedDateFromTo.save(criteria.ReceivedDateFromTo)">{{$t('ok')}}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="" sm="1" md="1" lg="1">
                <v-text-field outlined dense hide-details v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field> 
              </v-col>
            </v-row>
            </v-container> -->
          <v-dialog v-model="dialog.dialogAddEditWindow" max-width="100%" eager >
            <v-card>
              <!-- 5555 -->
              <v-card-title> 
                <span class="headline" style="color: #003057;">{{ $t('WpLabReceive.header_main') }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-icon  
                  style="font-size: 30px; position: absolute;left: 95%; top:5%;"
                  @click="close">
                    mdi-close
                  </v-icon>
                  <v-row no-gutters justify="start" class="mb-2">
                    <!-- ปุ่มรับ -->
                    <v-col cols="auto" class="d-flex align-center me-2">
                      <v-btn class="icon-button" @click="openDialogReceiveSpecimen" color="#04AB2F">
                        <v-icon large class="me-2">mdi-file-check-outline</v-icon>
                        <span class="font-weight-bold">{{ $t('WpLabReceive.receiveLab') }}</span>
                      </v-btn>
                    </v-col>

                    <!-- ปุ่มปฏิเสธ -->
                    <v-col cols="auto" class="d-flex align-center me-2">
                      <v-btn class="icon-button" @click="openDialogRejectSpecimen" color="#CC0202">
                        <v-icon large class="me-2">mdi-file-remove-outline</v-icon>
                        <span class="font-weight-bold">{{ $t('WpLabReceive.rejectLab') }}</span>
                      </v-btn>
                    </v-col>

                    <!-- ปุ่มพิมพ์ใบคำขอตรวจ -->
                    <v-col cols="auto" class="d-flex align-center me-2">
                      <v-btn class="icon-button" @click="checkPrintRequestSelected" color="#003057">
                        <v-icon large class="me-2">mdi-printer-outline</v-icon>
                        <span>{{ $t('WpLabReceive.printOrderReport') }}</span>
                      </v-btn>
                    </v-col>

                    <!-- ปุ่มพิมพ์สติ๊กเกอร์ -->
                    <v-col cols="auto" class="d-flex align-center me-2">
                      <v-btn class="icon-button" @click="printSpecimenSticker('S')" color="#0073BE">
                        <v-icon large class="me-2">mdi-barcode</v-icon>
                        <span>{{ $t('WpLabReceive.printSticker') }}</span>
                      </v-btn>
                    </v-col>

                    <!-- ปุ่มคืน -->
                    <v-col cols="auto" class="d-flex align-center me-2">
                      <v-btn class="icon-button" @click="openDialogreturnSpecimen" outlined color="primary">
                        <v-icon large class="me-2">mdi-restore</v-icon>
                        <span class="font-weight-bold">{{ $t('WpLabReceive.returnLab') }}</span>
                      </v-btn>
                    </v-col>

                    <!-- ปุ่มยกเลิก -->
                    <v-col cols="auto" class="d-flex align-center me-2">
                      <v-btn class="icon-button" @click="openDialogCancelSpecimen" outlined color="primary">
                        <v-icon large class="me-2">mdi-cancel</v-icon>
                        <span class="font-weight-bold">{{ $t('WpLabReceive.cancelOrderItem') }}</span>
                      </v-btn>
                    </v-col>
                  </v-row>



                  <v-row dense flat>
                  <v-tabs center-active class="ma-0 pa-0" dense flat v-model="active_tab">
                    <v-tab
                      v-model="tabPerson"
                      ref="tabPerson" 
                      v-show="vDataTable.editedItem.company_flag != 'Y'"
                      style="cursor: default;">
                      {{ $t('WpLabReceive.patient_info') }}
                    </v-tab>
                      <v-tab-item eager v-show="vDataTable.editedItem.company_flag != 'Y'">
                        <v-card>
                          <v-row no-gutters class="mt-3">
                            <!-- <v-col cols="12" sm="12" md="2">
                              <img :src="utils.imageProfile(idCardBase64)" id='thumb_image' height="150" weight="150"/>
                            </v-col> -->
                            <v-col cols="2" sm="2" md="2" xl="2">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="hn" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.HN') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                            <v-col cols="2" sm="2" md="2" xl="2">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="prefix_desc" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.prefix') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                            <v-col cols="2" sm="2" md="2" xl="2">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="first_name" :readonly="readonlyBoolean"
                                    >
                                    <template v-slot:label>
                                      <span class="input__label text-title">{{ $t('WpLabReceive.firstname') }}</span>
                                    </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                            <v-col cols="2" sm="2" md="2" xl="2">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="middle_name" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.middlename') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                            <v-col cols="2" sm="2" md="2" xl="2">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="last_name" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.lastname') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                            <!-- <v-col cols="3" sm="3" md="3">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="current_order_id" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.OrderId') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col> -->
                          </v-row>
                          <v-row no-gutters class="mt-3">
                            <v-col cols="2" sm="2" md="2">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="dateBrithdayText" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.birthday') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                            <v-col cols="2" sm="2" md="2">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="age" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.age') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                            <v-col cols="2" sm="2" md="2">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="sex" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.sex') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                            <v-col cols="2" sm="2" md="2">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="request_by" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.user_created') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row no-gutters class="mt-3">
                            <v-col cols="3" sm="3" md="3">
                              <div class="mx-3">
                                <!-- <v-dialog
                    ref="dialogReceivedDateFromTo"
                    v-model="dialog.dialogReceivedDateFromTo"
                    :return-value.sync="criteria.ReceivedDateFromTo"
                    persistent
                    width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn 
                      
                      dense
                        hide-details
                        width="100%"
                        v-model="dateRangeText"
                        prepend-icon="mdi-calendar"
                        readonly
                        color="#003057"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon color="#FFF" class="mr-1">mdi-calendar</v-icon> 
                        <span class="no-wrap-text">
                          {{ $t('WpAcctInvoices.ReceivedDate') }} {{ dateRangeText }}
                        </span>
                      </v-btn>

                     

                    </template>
                    <v-date-picker
                      locale="th-th"
                      v-model="criteria.ReceivedDateFromTo"
                      range
                      scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialog.dialogReceivedDateFromTo = false">{{$t('cancel')}}</v-btn>
                      <v-btn text color="primary" @click="$refs.dialogReceivedDateFromTo.save(criteria.ReceivedDateFromTo)">{{$t('ok')}}</v-btn>
                    </v-date-picker>
                                </v-dialog> -->
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="dateCollectionText" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.collectDate') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                          </v-row>


                          <!-- <v-row no-gutters class="mt-3">
                            <v-col cols="3" sm="3" md="3">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="prefix_desc" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.prefix') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                            <v-col cols="3" sm="3" md="3">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="first_name" :readonly="readonlyBoolean"
                                    >
                                    <template v-slot:label>
                                      <span class="input__label text-title">{{ $t('WpLabReceive.firstname') }}</span>
                                    </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                            <v-col cols="3" sm="3" md="3">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="middle_name" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.middlename') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                            <v-col cols="3" sm="3" md="3">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="last_name" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.lastname') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                          </v-row> -->
                          <!-- <v-row no-gutters class="mt-3">
                            <v-col cols="3" sm="3" md="3">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="hn" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.HN') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                            <v-col cols="3" sm="3" md="3">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="sex" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.sex') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                            <v-col cols="3" sm="3" md="3">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="dateBrithday" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.birthday') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                            <v-col cols="3" sm="3" md="3">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="age" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.age') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                          </v-row> -->
                          <!-- <v-row no-gutters class="mt-3 mb-5">
                            <v-col cols="3" sm="3" md="3">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="dateCollection" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.collectDate') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                            <v-col cols="3" sm="3" md="3">
                              <div class="mx-3">
                                <v-text-field
                                      outlined dense hide-details
                                      v-model="request_by" :readonly="readonlyBoolean"
                                    >
                                      <template v-slot:label>
                                        <span class="input__label text-title">{{ $t('WpLabReceive.user_created') }}</span>
                                      </template>
                                    </v-text-field>
                              </div>
                            </v-col>
                          </v-row> -->
                          
                          <!-- <v-row>
                            <v-col>
                              <v-divider class="mx-auto"></v-divider>
                              <v-spacer></v-spacer>
                            </v-col>
                          </v-row> -->
                          <v-row>
                            <v-data-table
                              v-model="vDataTable2.selected"
                              :headers="headersDialogAddEditWindow"
                              :items="vDataTable2.data"
                              :search="vDataTable2.search"
                              fixed-header
                              :page.sync="vDataTable2.options.page"
                              :itemsPerPage.sync="vDataTable2.options.itemsPerPage"
                              :options.sync="vDataTable2.options"
                              :height="$vuetify.breakpoint.height - 430 - offsetAppBar"
                              show-select
                              :footer-props="{
                                itemsPerPageText: $t('itemsPerPageText'),
                                itemsPerPageAllText: $t('itemsPerPageAllText'),
                                showFirstLastPage: true,
                                showCurrentPage: true,
                                firstIcon: 'mdi-arrow-collapse-left',
                                lastIcon: 'mdi-arrow-collapse-right',
                                prevIcon: 'mdi-minus',
                                nextIcon: 'mdi-plus',
                              }"
                              item-key="OrderItemId"
                              class="fill-height mt-6"
                              show-expand single-expand>

                            <!-- <template v-slot:[`header.data-table-select`]="{ on, props }">
                              <tr>
                                <td>
                                  <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
                                </td>
                                <td v-if="vDataTable2.selected.length > 0">
                                  {{vDataTable2.selected.length}}
                                </td>
                              </tr>
                            </template> -->
                            <template v-slot:item.data-table-expand="{ item, expand, isExpanded }">
                              <v-icon
                                v-if="item.probes && item.probes.length > 0"
                                @click.stop="expand(!isExpanded)"
                              >
                                {{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                              </v-icon>
                            </template>
                            <template v-slot:expanded-item="{ item }">
                              <td :colspan="headers.length" style="background-color: #f0f0f0; padding: 3;">
                                <v-card class="ma-3" style="overflow-x: auto; ">
                                  <v-data-table
                                    :headers="probeHeaders"
                                    :items="item.probes"
                                    dense
                                    hide-default-footer
                                    class="elevation-1"
                                  />
                                </v-card>
                              </td>
                            </template>
                            <template v-slot:[`item.remark`]="{ item }">
                              <div v-if="item.remark">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" :color="item.remark ? 'red' : 'gray'" class="mr-2" large @click="viewRemark(item)">text_format</v-icon>
                                  </template>
                                  <span>{{ $t('WpLabRequest.remark') }}</span>
                                </v-tooltip>
                              </div>
                            </template>
                            <template v-slot:item.is_get_back="{ item }">
                              <v-icon v-if="item.is_get_back === 1" large color="green">mdi-checkbox-marked-circle</v-icon>
                            </template>
                            <template v-slot:item.is_urgent="{ item }">
                              <v-icon v-if="item.is_urgent === 1" large color="red">mdi-bell-outline</v-icon>
                            </template>                          
                            <template v-slot:item.rejectSpecimen="{ item }">
                              <v-icon v-if="item.status === 'CO' && item.is_hist === 1" large color="gray" @click="viewSpecimenStatusHist(item)">mdi-check</v-icon>
                              <v-icon v-if="item.status === 'RF' && item.is_hist === 1" large color="gray" @click="viewSpecimenStatusHist(item)">mdi-exclamation</v-icon>
                              <v-icon v-if="item.status === 'OP' && item.is_hist === 1" large color="gray" @click="viewSpecimenStatusHist(item)">mdi-history</v-icon>
                              <v-icon v-if="item.status === 'CA' && item.is_hist === 1" large color="gray" @click="viewSpecimenStatusHist(item)">mdi-cancel</v-icon>
                            </template>
                            <!-- <template v-slot:item.actions="{ item }">
                              <v-icon color="teal" small class="mr-2" @click="editLanguageItem(item)">edit</v-icon>
                              <v-icon color="pink" small class="mr-2" @click="deleteLanguageConfirm(item)">delete</v-icon>
                            </template> -->
                            <!-- <template v-slot:[`item.status_desc`]="{ item }">
                              <v-icon v-if="item.status_desc == 'รับสิ่งส่งตรวจแล้ว'" large color="green">
                                mdi-check-circle
                              </v-icon>
                              <v-tooltip top v-else-if="item.status_desc == 'ปฏิเสธสิ่งส่งตรวจแล้ว'">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon large color="red" v-bind="attrs" v-on="on">
                                    mdi-alert-circle-outline
                                  </v-icon>
                                </template>
                                <span>{{ item.reject_reason }}</span>
                              </v-tooltip>
                            </template> -->
                          </v-data-table>
                        </v-row>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                  </v-row>
                </v-container>
              </v-card-text>
              <!-- <v-card-actions dense flat class="my-0 py-0">
                <v-row row wrap  class="ma-0 pa-0" align="center" justify="center" dense flat>
                  <v-col align="center" justify="center" dense flat>
                    <v-btn dense text class="mx-3 px-3 my-0 py-0" align="center" justify="center" outlined color="primary" @click="openDialogreturnSpecimen">{{$t('WpLabReceive.returnLab')}}</v-btn>
                    <v-btn dense text class="mx-3 px-3 my-0 py-0" align="center" justify="center" outlined color="primary" @click="openDialogReceiveSpecimen">{{$t('WpLabReceive.receiveLab')}}</v-btn>
                    <v-btn dense text class="mx-3 px-3 my-0 py-0" align="center" justify="center" outlined color="primary" @click="openDialogRejectSpecimen">{{$t('WpLabReceive.rejectLab')}}</v-btn>
                    <v-btn dense text class="mx-3 px-3 my-0 py-0" align="center" justify="center" outlined color="primary" @click="checkPrintRequestSelected">{{$t('WpLabReceive.printOrderReport')}}</v-btn>
                    <v-btn dense text class="mx-3 px-3 my-0 py-0" align="center" justify="center" outlined color="primary" @click="printSpecimenSticker('S')">{{$t('WpLabReceive.printSticker')}}</v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
              <v-card-actions dense flat class="my-0 py-0">
                <v-row row wrap  class="ma-0 pa-0" align="center" justify="center" dense flat>
                  <v-col align="center" justify="center" dense flat>
                    <v-btn dense text class="mx-3 px-3 my-0 py-0" align="center" justify="center" outlined color="primary" @click="close">{{$t('WpLabReceive.back')}}</v-btn>
                  </v-col>
                </v-row>
              </v-card-actions> -->
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog.dialogReceiveSpecimen" max-width="500px" eager>
            <v-card>
              <v-card-title>
                <span class="headline">{{ $t('WpLabReceive.receiveLab') }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-combobox
                        outlined dense hide-details
                        :label="$t('WpLabReceive.paymentType')"
                        v-model="vDataTable.editedItem.paymentType"
                        :items="paymentTypeList"
                        item-value="payment_type_skey"
                        item-text="payment_type_name"
                      >
                        <template v-slot:label>
                          <span class="input__label text-title">{{ $t('WpLabReceive.paymentType') }}</span>
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-combobox
                        outlined dense hide-details
                        :label="$t('WpLabReceive.project')"
                        v-model="vDataTable.editedItem.project"
                        :items="projectList"
                        item-value="project_skey"
                        item-text="project_name"
                      >
                        <template v-slot:label>
                          <span class="input__label text-title">{{ $t('WpLabReceive.project') }}</span>
                        </template>
                      </v-combobox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions dense flat class="my-0 py-0">
                <v-spacer></v-spacer>
                <v-row row wrap  class="ma-0 pa-0" align="center" justify="center" dense flat>
                  <v-col align="center" justify="center" dense flat>
                    <v-btn dense text class="mx-3 px-3 my-0 py-0" align="center" justify="center" outlined color="primary" @click="receiveSelected">{{$t('ok')}}</v-btn>
                    <v-divider class="mx-1" inset vertical></v-divider>
                    <v-btn dense text class="mx-3 px-3 my-0 py-0" align="center" justify="center" outlined color="primary" @click="closeDialogReceiveSpecimen">{{$t('cancel')}}</v-btn>
                  </v-col>
                </v-row>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog.dialogRejectSpecimen" max-width="500px" eager>
            <v-card>
              <v-card-title>
                <span class="headline">{{ $t('dialog.reject.header') }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row no-gutters>
                    <v-col cols="12" sm="12" md="12">
                      <div class="mx-3">
                        <v-combobox
                        outlined dense hide-details
                        v-model="vDataTable.selectedItem.rejectReason"
                        :items="rejectReasonList"
                        item-value="code"
                        item-text="description"
                      >
                        <template v-slot:label>
                          <span class="input__label text-title">{{ $t('dialog.reject.please_specify_data') }}</span>
                        </template>
                      </v-combobox>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="mt-2">
                    <v-col cols="12" sm="12" md="12">
                      <div class="mx-3">
                        <v-text-field
                          outlined dense hide-details
                          v-model="vDataTable.selectedItem.rejectRemark" 
                        >
                          <template v-slot:label>
                            <span class="input__label text-title">{{ $t('WpLabReceive.remark') }}</span>
                          </template>
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="mt-2">
                  <v-col cols="12" sm="12" md="12">
                      <div class="mx-3">
                        <v-text-field
                          outlined dense hide-details
                          v-model="vDataTable.selectedItem.rejectUser" 
                        >
                          <template v-slot:label>
                            <span class="input__label text-title">{{ $t('WpLabReceive.rejectUser') }}</span>
                          </template>
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions dense flat class="my-0 py-0">
                <v-spacer></v-spacer>
                <v-row row wrap  class="ma-0 pa-0 mb-2" align="center" justify="center" dense flat>
                  <v-col align="center" justify="center" dense flat>
                    <v-btn dense text class="mx-3 px-3 my-0 py-0" align="center" justify="center" outlined color="primary" @click="confirmCancelReceive">{{$t('ok')}}</v-btn>
                    <v-divider class="mx-1" inset vertical></v-divider>
                    <v-btn dense text class="mx-3 px-3 my-0 py-0" align="center" justify="center" outlined color="primary" @click="closeDialogRejectSpecimen">{{$t('cancel')}}</v-btn>
                  </v-col>
                </v-row>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          
          <!-- <v-text-field outlined dense hide-details v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field> -->
        <!-- </v-toolbar> -->
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.data-table-select="{ isSelected, select }">
        <v-simple-checkbox :value="isSelected" :ripple="false" @input="select($event)" ></v-simple-checkbox>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="teal" small class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">edit</v-icon>
          </template>
          <span>{{ $t('edit') }}</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.lab_status`]="{ item }">
        {{ getStatusName(item.lab_status, item.is_received_check, item.group_status_ratio) }}
      </template>
      <template v-slot:[`item.is_approved`]="{ item }">
        <span v-if="item.lab_status === 'LASTAPPROVE'">
          {{ getStatusApproveName(item.is_approved) }}
        </span>
      </template>
      <template v-slot:item.is_get_back="{ item }">
        <!-- <v-icon v-if="item.is_get_back === 1" large color="green">mdi-checkbox-marked-circle</v-icon> -->
<!-- {{ item.is_get_back }} -->
        <v-icon v-if="item.is_get_back === 1" large color="red">mdi-bell-outline</v-icon>
        <v-icon v-else large >mdi-bell-outline</v-icon>
      </template>
      <template v-slot:item.invoice_desc="{ item }">
        <v-row>
          <v-col cols="12">
            <v-container class="d-flex justify-center" v-if="item.invoice_desc !== null" > <!-- ทำให้ v-container อยู่ตรงกลาง -->
              <div
                :style="{
                  backgroundColor: item.invoice_desc === $t('WpLabReceive.receiptGenerated') || item.invoice_desc === $t('WpLabReceive.receiptSent') ? '#35C75A' : '#FF2626',
                  color: '#FFFFFF',
                  padding: '8px',
                  textAlign: 'center',
                  width: '180px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: '40px',
                      }"
                    >
                {{ item.invoice_desc }}
              </div>
            </v-container>
            <!-- <v-container v-else class="d-flex justify-center"  > 
              <div
                      :style="{
                        backgroundColor: item.invoice_desc === 'ออกใบเสร็จแล้ว' ? '#35C75A' : '#FF2626',
                        color: '#FFFFFF',
                        padding: '8px',
                        textAlign: 'center',
                        width: '180px', 
                        display: 'flex',
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        minHeight: '40px' 
                      }"
                    >
                {{ item.invoice_desc }}
              </div>
            </v-container> -->
          </v-col>
        </v-row>
        <!-- {{ item.invoice_desc }} -->
      </template>
      <template v-slot:item.is_urgent="{ item }">
        <v-icon v-if="item.is_urgent === 1" large color="red">mdi-checkbox-marked-circle</v-icon>
      </template>
      <!-- <template v-slot:item.status="{ item }">
        <v-select dense hide-details
          :items="statusList"
          v-model="item.status"
          item-text="status_name"
          item-value="status"
          @change="setUpdateFlag(item)"
        ></v-select>
      </template> -->
      <template v-slot:[`item.data-table-no`]="{ index }">
        {{((vDataTable.options.page - 1) * vDataTable.options.itemsPerPage) + index + 1}}
      </template>
      <template v-slot:no-data>
        <v-alert type="info" border="bottom" colored-border elevation="2">
          {{$t('noData')}}
        </v-alert>
      </template>
      <template v-slot:[`item.channel_customer_type`]="{ item }">
        <v-row class="text-center d-flex flex-column align-center justify-center">
          <div>
            <v-icon large color="primary">
            {{ item.channel == 'I'? 'mdi-alpha-i-circle' : 'mdi-alpha-g-circle'}}
            </v-icon>
            <v-icon large color="pink">
            {{ item.customer_type == 'G'? 'mdi-alpha-g-circle' : ''}}
          </v-icon>
          </div>
        </v-row>
      </template>
      <template v-slot:[`item.company_flag`]="{ item }">
        <v-icon large>
          {{ item.company_flag == 'Y'? 'mdi-domain' : 'mdi-account' }}
        </v-icon>
      </template>
      <template v-slot:[`item.is_attach_file`]="{ item }">
        <v-icon color="primary">
          {{ item.is_attach_file == 'Y'? 'mdi-attachment' : '' }}
        </v-icon>
      </template>
      <template v-slot:no-results>
        <v-alert type="warning">
          {{stringFormat($t('searchNotFound'),vDataTable.search)}}
        </v-alert>
      </template>
      <template v-slot:footer>
        <tr class="sticky-table-footer" style="position: absolute">
          <td style="background-color: aq;">Selected({{vDataTable.selected.length}})s</td>
        </tr>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-card class="elevation-10">
            <v-card-text>
              <v-data-table v-model="item.selectedLanguage"
                :headers="LabOrderItemHeadersList"
                :items="item.OrderItemId"
                :search="item.searchLanguage"
                :footer-props="{
                  itemsPerPageText: $t('itemsPerPageText'),
                  itemsPerPageAllText: $t('itemsPerPageAllText'),
                  showFirstLastPage: true,
                  showCurrentPage: true,
                  firstIcon: 'mdi-arrow-collapse-left',
                  lastIcon: 'mdi-arrow-collapse-right',
                  prevIcon: 'mdi-minus',
                  nextIcon: 'mdi-plus',
                }"
                item-key="OrderItemId"
                class="elevation-1">
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>Language</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog.dialogLanguage" max-width="500px" eager>
                      <v-card>
                        <v-card-title>
                          <span class="headline">{{ formLanguageTitle }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="12" md="12">
                                <v-autocomplete
                                  :items="languages"
                                  item-value="language_skey"
                                  item-text="language_comment"
                                  v-model="vDataTable.editedLanguageItem.language_skey"
                                  :label="$t('language')"
                                  :readonly="languageEdit">
                                </v-autocomplete>
                              </v-col>
                              <v-col cols="12" sm="12" md="12">
                                <v-text-field :label="$t('ProductMaint.productDetailName')" v-model="vDataTable.editedLanguageItem.product_language_desc"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                            <v-btn outlined color="primary" @click="closeLanguage">{{$t('cancel')}}</v-btn>
                            <v-btn outlined color="primary" @click="saveLanguage">{{$t('save')}}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
import Base64Binary from 'base64-arraybuffer'
import moment from 'moment'

export default {
  components: {
  },

  props: ['parentComponent'],

  data () {
    return {
      utils: require('@/utils'),
      stringFormat: require('string-format'),
      appName: process.env.VUE_APP_DB_APP_NAME,
      rules: {
        winName: value => {
          const pattern = /^[a-zA-Z0-9$@$!%*?&#^-_. +]+$/
          return pattern.test(value) || 'Invalid Window Name'
        },
      },
      readonlyValue: 'true',
      dialog: {
        dialogProgress: false,
        dialogAddEditWindow: false,
        dialogLanguage: false,
        dialogReceivedDateFromTo: false,
        dialogOTP: false,
        dialogUpload: false,
        dialogReceiveSpecimen: false,
        dialogRejectSpecimen: false,
        dialogStatusHist: false,
        dialogviewRemark: false
      },
      criteria: {
        /* ReceivedDateFromTo: ['2020-10-01', '2020-10-31'], */
        ReceivedDateFromTo: [new Date(Date.now() - 1209600000).toISOString().slice(0, 10), new Date().toISOString().slice(0, 10)],
      },
      vDataTable: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        editedLanguageIndex: -1,
        editedLanguageItem: {
        },
        defaultLanguageItem: {
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
        selectedItem: {},
      },
      vDataTable2: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        editedLanguageIndex: -1,
        editedLanguageItem: {
        },
        defaultLanguageItem: {
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      vDataTableStatusHist: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        editedLanguageIndex: -1,
        editedLanguageItem: {
        },
        defaultLanguageItem: {
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      progressMessage: '',
      menuBrithday: false,
      menuReceive: false,
      languages: [],
      languageEdit: true,
      statusList: [],
      viewList: [],
      lab_view_skey: '',
      statusListAll: [
        { status_name: 'All', status: '' },
        { status_name: 'Complete', status: 'CO' },
        { status_name: 'Open', status: 'OP' },
        { status_name: 'Reject', status: 'RF' },
        // { status_name: 'WpLabReceive.statusObj.LASTAPPROVE', status: 'LASTAPPROVE' },
        // { status_name: 'WpLabReceive.statusObj.CA', status: 'CA' },
      ],
      labList: ['Anatomical Pathology (ห้องปฏิบัติการทางพยาธิวิทยากายวิภาค )', 'Microbiology (ห้องปฏิบัติการจุลชีววิทยา)', 'Blood Bank (ห้องปฎิบัติการคลังเลือด)', 'Flow cytometry (ห้องปฏิบัติการโฟลไซโทเมทรี)', 'Histocompatibility and Immunogenetics (ห้องปฏิบัติการตรวจเนื้อเยื่อ)', 'Blood Disease Diagnostic (ห้องปฏิบัติการวินิจฉัยโรคเลือด)', 'Pharmacogenomics (ห้องปฏิบัติการเภสัชพันธุศาสตร์)', 'VIROLOGY (ห้องปฏิบัติการไวรัสวิทยา)', 'Toxicology (ห้องปฏิบัติการพิษวิทยา)', 'Human Genetics (ห้องปฎิบัติการมนุษย์พันธุศาสตร์)', 'Hematology (ห้องปฏิบัติการโลหิตวิทยา)', 'Clinical Chemistry (ห้องปฏิบัติการเคมีคลินิก)', 'Clinical Microscopy (ห้องปฎิบัติการจุลทรรศนศาสตร์คลินิก)', 'Immunology (ห้องปฏิบัติการภูมิคุ้มกันวิทยา)'],
      status: '',
      lab: '',
      FindStatus: '',
      FindTestItem: '',
      FindOrderId: '',
      FindHN: '',
      phone: '',
      user: '',
      order_id: '',
      uploadList: [],
      provinceId: 0,
      districtId: 0,
      subDistrictId: 0,
      provinceName: '',
      districtName: '',
      subDistrictName: '',
      // provinceList: require('@/data/thai_provinces.json'),
      // districtList: require('@/data/thai_amphures.json'),
      // subDistrictList: require('@/data/thai_tambons.json'),
      subDistrict: [],
      otp: '',
      otpCode: 'VUEJ',
      refCode: '',
      hn: '',
      idCard: '',
      firstName: '',
      lastName: '',
      tel: '',
      tempPhone: '',
      uploadDocumentList: [],
      tabPerson: '',
      tabCompany: '',
      menuBirthday: '',
      packageNo: '',
      find_PackageNo: '',
      regEmail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      regTelephone: /^((0)(\d{9}))$/,
      active_tab: 0,
      prefixList: [],
      paymentTypeList: [],
      projectList: [],
      rejectReasonList: [],
      idCardBase64: '',
      successMsg: '',
      guaranteeList: [],
      rejectList: [],
      guaranteeProvinceName: '',
      guaranteeName: '',
      rejectName: '',
      optionsCreditLimit: {
        locale: 'th-TH',
        // prefix: '฿',
        suffix: '฿',
        length: 20,
        precision: 0
      },
      properties: {
        class: 'custom-label-color custom-placeholder-color text-title',
        color: 'black'
      },
      dialogpdfShow: false,
      // for stop red warning
      uploadPercentage: 0,
      pdfShow: '',
      custName: '',
      prefix_desc: '',
      first_name: '',
      last_name: '',
      dateBrithday: '',
      age: 0,
      sex: '',
      dateSend: '',
      dateCollection: '',
      user_created: '',
      lab_status: '',
      itemRemark: '',
      middle_name: '',
      request_by: '',
    }
  },

  computed: {
    ...mapGetters(['getShowAppBar', 'getAppBarHeight']),
    ...mapState({
      userID: state => `${state.user.profile.user_id}`,
      userEmail: state => `${state.user.profile.email}`,
    }),
    selectDate () {
      var text = '$vuetify.datePicker.itemsSelected'
      text = 'ช่วงเวลาค้นหาข้อมูล'
      return text
    },
    formTitle () {
      return this.vDataTable.editedIndex === -1 ? this.$t('RegisterMaint.NewRegister') : this.$t('RegisterMaint.Title')
    },
    formLanguageTitle () {
      return this.vDataTable.editedLanguageIndex === -1 ? this.$t('SubscribeMaint.newSubscribeLanguage') : this.$t('SubscribeMaint.editSubscribeLanguage')
    },
    headers () {
      return [
        // { text: this.$t('actions'), value: 'actions', width: '60px', sortable: false },
        { text: this.$t('WpLabReceive.date_receive'), value: 'received_date', align: 'left', class: 'text-xl-left body-1 black--text', width: '180px' },
        { text: this.$t('WpLabReceive.specimenTypeId'), value: 'specimen_type_id', align: 'left', class: 'text-xl-left body-1 black--text', width: '180px' },
        { text: this.$t('WpLabReceive.date_result'), value: 'date_result', align: 'left', class: 'text-xl-left body-1 black--text', width: '180px' },
        // { text: this.$t('WpLabReceive.is_get_back'), value: 'is_get_back', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('WpLabReceive.paymentType'), value: 'payment_type', align: 'left', class: 'text-xl-left body-1 black--text', width: '180px' },
        // { text: this.$t('WpLabReceive.paymentStatus'), value: 'invoice_desc', align: 'left', class: 'text-xl-left body-1 black--text', width: '220px' },
        { text: this.$t('WpLabReceive.fullname'), value: 'patient_name', align: 'left', class: 'text-xl-left body-1 black--text', width: '300px' },
        { text: this.$t('WpLabReceive.HN'), value: 'hn', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.date_created'), value: 'date_created', align: 'left', class: 'text-xl-left body-1 black--text', width: '180px' },
        { text: this.$t('WpLabReceive.date_send'), value: 'date_send', align: 'left', class: 'text-xl-left body-1 black--text', width: '180px' },
        // { text: this.$t('WpLabReceive.cust_name'), value: 'cust_name', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.OrderItemLaboratoryName'), value: 'view_desc', align: 'left', class: 'text-xl-left body-1 black--text', width: '180px' },
        { text: this.$t('WpLabReceive.packageNo'), value: 'package_no', align: 'left', class: 'text-xl-left body-1 black--text', width: '180px' },
        { text: this.$t('WpLabReceive.OrderId'), value: 'order_id', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('WpLabReceive.PackageNo'), value: 'package_no', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('WpLabReceive.IdCard'), value: 'id_card', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('WpLabReceive.user_created'), value: 'user_created', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.labStatus'), value: 'lab_status', align: 'left', class: 'text-xl-left body-1 black--text', width: '150px' },
        { text: this.$t('WpLabReceive.labApproveStatus'), value: 'is_approved', align: 'left', class: 'text-xl-left body-1 black--text', width: '150px' },
      ]
    },
    LabOrderItemHeadersList () {
      return [
        { text: this.$t('actions'), value: 'actions', width: '60px', sortable: false },
        { text: this.$t('WpLabReceive.OrderItemId'), value: 'OrderItemId', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.OrderItemDesc'), value: 'OrderItemdesc', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.OrderItemLaboratoryName'), value: 'OrderItemLaboratoryName', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.OrderItemSpecimenType'), value: 'OrderItemSpecimenType', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.OrderItemPrice'), value: 'OrderItemPrice', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('WpLabReceive.is_get_back'), value: 'is_get_back', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('WpLabReceive.OrderItemUrgent'), value: 'OrderItemUrgent', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.lis_sid'), value: 'lis_sid', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.OrderItemRemark'), value: 'remark', align: 'center', class: 'text-xl-left body-1 black--text' },
      ]
    },
    headersDialogAddEditWindow () {
      return [
        { text: this.$t('WpLabReceive.OrderItemId'), value: 'OrderItemId', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.OrderItemDesc'), value: 'OrderItemdesc', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('WpLabReceive.is_urgent'), value: 'is_urgent', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.cust_name'), value: 'cust_name', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('WpLabReceive.is_get_back'), value: 'is_get_back', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.OrderItemLaboratoryName'), value: 'OrderItemLaboratoryName', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.OrderItemSpecimenType'), value: 'OrderItemSpecimenType', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.OrderItemPrice'), value: 'OrderItemPrice', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.date_receive'), value: 'sid_received_date', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.lab_item_status'), value: 'status_desc', align: 'center', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.lis_sid'), value: 'specimen_type_id', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.OrderItemRemark'), value: 'remark', align: 'center', class: 'text-xl-left body-1 black--text' },
        { text: '', value: 'rejectSpecimen', align: 'center', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpLabReceive.receivedUser'), value: 'sid_received_user', align: 'center', class: 'text-xl-left body-1 black--text' },
      ]
    },
    subHeaders () {
      return [
        { text: this.$t('navWindow.windowName'), value: 'win_name' },
        { text: this.$t('createUser'), value: 'create_user_id' },
      ]
    },
    subHeadersLanguage () {
      return [
        { text: '', align: 'center', value: 'data-table-select' },
        { text: this.$t('actions'), value: 'actions', sortable: false },
        { text: this.$t('language'), value: 'language_comment' },
        { text: this.$t('SubscribeMaint.name'), value: 'name', align: 'right' },
      ]
    },
    statusHistheaders () {
      return [
      { text: this.$t('WpLabReceive.status'), value: 'status', align: 'left', class: 'text-xl-left body-1 black--text' },
      { text: this.$t('WpLabReceive.reason'), value: 'description', align: 'left', class: 'text-xl-left body-1 black--text' },
      { text: this.$t('WpLabReceive.note'), value: 'remark', align: 'left', class: 'text-xl-left body-1 black--text' },
      { text: this.$t('WpLabReceive.rejectUser'), value: 'reject_user', align: 'left', class: 'text-xl-left body-1 black--text' },
      { text: this.$t('WpLabReceive.date'), value: 'date_created', align: 'left', class: 'text-xl-left body-1 black--text' },
      { text: this.$t('WpLabReceive.userHist'), value: 'user_created', align: 'left', class: 'text-xl-left body-1 black--text' },
      ]
    },
    probeHeaders () {
      return [
      { text: this.$t('WpLabReceive.code'), value: 'probe_cd', align: 'left', class: 'text-xl-left body-1 black--text' },
      { text: this.$t('WpLabReceive.desc'), value: 'probe_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
      { text: this.$t('WpLabReceive.OrderItemPrice'), value: 'price', align: 'left', class: 'text-xl-left body-1 black--text' }
      ]
    },
    offsetAppBar () {
      console.log('this.getShowAppBar', this.getShowAppBar)
      console.log('this.getAppBarHeight', this.getAppBarHeight)
      return this.getShowAppBar ? this.getAppBarHeight : 0
    },
    // dateRangeText () {
    //   return this.criteria.ReceivedDateFromTo.join(' ~ ')
    // },
    dateRangeText () {
      if (this.criteria.ReceivedDateFromTo.length > 0) {
        return this.criteria.ReceivedDateFromTo.map(date =>
          this.convertToThaiDate(date)
        ).join(' ~ ')
      }
      return ''
    },
    // filterProvince () {
    //   let options = this.provinceList
    //   return options.filter(o => o.id === this.vDataTable.editedItem.province_id)
    // },
    // filterDistrict () {
    //   let options = this.districtList
    //   return options.filter(o => o.province_id === this.vDataTable.editedItem.province_id)
    // },
    // filterSubDistrict () {
    //   let options = this.subDistrictList
    //   return options.filter(o => o.amphure_id === this.vDataTable.editedItem.district_id)
    // },
    filterUploadMaster () {
      let options = this.uploadList
      return options.filter(o => o.company_flag === this.vDataTable.editedItem.company_flag)
    },
    readonlyBoolean () {
      // Convert to boolean
      return this.readonlyValue === 'true'
    },
    dateBrithdayText () {
      return this.dateBrithday
        ? this.convertToThaiDate(this.dateBrithday)
        : '' // Return a default value like '-' if undefined
    },
    dateCollectionText () {
      return this.dateCollection
        ? this.convertToThaiDate(this.dateCollection)
        : '' // Return a default value like '-' if undefined
    },
  },

  watch: {
    'dialog.dialogAddEditWindow' (val) {
      val || this.close()
    }
  },

  async created () {
    this.retrieveView()
    this.getPrefix()
    // this.status = 'COLLECTION'
    this.status = 'OP'
    this.retrieveLabReceive()
  },

  mounted () {
    // this.retrieveWPPaymentTypeList()
    // this.retrieveWPProjectList()
    this.retrieveRejectReasonList()
  },

  updated () {
  },

  methods: {
    convertToThaiDate (date) {
      let [year, month, day] = date.split('-')
      year = parseInt(year) + 543
      return `${day}-${month}-${year}`
    },
    formatDateTimeDisplay (date) {
      if (!date) return ''
      const d = new Date(date)
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getUTCFullYear() + 543
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      const seconds = String(d.getSeconds()).padStart(2, '0')
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`
    },
    clearData () {
      this.firstName = ''
      this.lastName = ''
      this.tel = ''
      this.idCard = ''
      this.criteria.ReceivedDateFromTo = [new Date(Date.now() - 1209600000).toISOString().slice(0, 10), new Date().toISOString().slice(0, 10)]
      this.status = ''
      this.FindOrderId = ''
      this.FindHN = ''
      this.lab = ''
      this.vDataTable.data = []
      localStorage.setItem('clickToGoStatus', '')
      this.retrieveLabReceive()
    },
    getPrefix () {
      this.axios.post(process.env.VUE_APP_API + '/getPrefix')
        .then(response => {
          this.prefixList = response.data
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async retrieveView (methodcode) {
      await this.axios.post(process.env.VUE_APP_API + '/wp_view_order_item/retrieveView' + process.env.VUE_APP_DATABASE_TYPE, {
        Lotskey: methodcode
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.viewList = response.data.data
            this.appSkey = response.data.data.length > 0 ? response.data.data[0]['Lotskey'] : -1
            this.initialize()
            // })
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async retrieveLabReceive (methodcode) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      if (this.criteria.ReceivedDateFromTo.length > 0) {
        this.dateSearchFrom = this.criteria.ReceivedDateFromTo[0]
        if (this.criteria.ReceivedDateFromTo.length > 1) {
          this.dateSearchTo = this.criteria.ReceivedDateFromTo[1]
        } else {
          this.dateSearchTo = new Date().toISOString().slice(0, 10)
        }
      }
      // if (localStorage.getItem('clickToGoStatus') === 'Download') {
      //   this.FindStatus = 'Download'
      // } else {
      //   this.FindStatus = 'Receive'
      // }
      const firstName = (this.firstName || '').trim()
      const findHN = (this.FindHN || '').trim()
      const findOrderId = (this.FindOrderId || '').trim()
      const findPackageNo = (this.find_PackageNo || '').trim()

      await this.axios.post(process.env.VUE_APP_API + '/receive/retrieveLabReceive' + process.env.VUE_APP_DATABASE_TYPE, {
        routing_seq: '30',
        logical_location_cd: null,
        find_order_id: findOrderId || null,
        dateSearch_From: this.dateSearchFrom,
        dateSearch_To: this.dateSearchTo,
        priority_cd: null,
        cust_no: null,
        facility_cd: null,
        visit_id: null,
        patient_id: null,
        id_card: null,

        first_Name: firstName || null,
        lastname: null,
        find_hn: findHN || null,
        status_list: this.status,
        patient_type_code: '',
        oqueue: null,
        proj_cd: null
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.initialize()
            this.appSkey = response.data.data.length > 0 ? response.data.data[0]['Lotskey'] : -1
            this.vDataTable.data = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    getStatusName (status, isReceivedCheck, collected) {
      switch (status) {
        case '' || 'OP':
          return this.$t('WpLabRequest.statusObj.OP')
        case 'COLLECTION':
          return isReceivedCheck === 'YES'
            ? `${this.$t('WpLabRequest.statusObj.RECEIVEDALL')} (${collected})`
            : this.$t('WpLabRequest.statusObj.COLLECTION')
        case 'RECEIVED':
          return this.$t('WpLabRequest.statusObj.RECEIVEDALL')
        case 'CA':
          return this.$t('WpLabRequest.statusObj.CA')
        case 'FIRSTAPPROVE':
          return this.$t('WpLabRequest.statusObj.FIRSTAPPROVE')
        case 'LASTAPPROVE':
          return this.$t('WpLabRequest.statusObj.LASTAPPROVE')
        default:
          return '-'
      }
    },
    getStatusApproveName (status) {
      switch (status) {
        case null:
          return this.$t('WpLabRequest.statusObj.labNotApprove')
        case '':
          return this.$t('WpLabRequest.statusObj.labNotApprove')
        case 0:
          return this.$t('WpLabRequest.statusObj.labNotApprove')
        case 1:
          return this.$t('WpLabRequest.statusObj.labApprove')
      }
    },
    getHistStatusName (status) {
      switch (status) {
        case 'OP':
          return this.$t('WpLabReceive.statusObj.return')
        case 'CO':
          return this.$t('WpLabReceive.statusObj.receive')
        case 'RF':
          return this.$t('WpLabReceive.statusObj.reject')
        case 'CA':
          return this.$t('WpLabReceive.statusObj.cancelSpecimen')
        default:
          return '-'
      }
    },
    async retrieveDetailFromOrderID (orderId, subCategorySkey) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      await this.axios.post(process.env.VUE_APP_API + '/receive/retrieveDetailFromOrderID' + process.env.VUE_APP_DATABASE_TYPE, {
        order_id: orderId,
        sub_category_skey: subCategorySkey
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTable2.data = response.data.data
            this.vDataTable2.selected = this.vDataTable2.data.filter(sel => sel.status === 'OP')
            // this.packageNo = response.data.data[0].package_no
            // this.custName = response.data.data[0].cust_name
            // this.user_created = response.data.data[0].user_created
            // this.patient_skey = localStorage.getItem('patient_skey')
            // localStorage.setItem('st_patient_skey', response.data.data[0].patient_skey)
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    // async checkPrintRequestSelected () {
    //   this.dialog.dialogProgress = true
    //   this.progressMessage = this.$t('waiting')
    //   var detailOrderId = ''
    //   var popupDateSendNotNull = ''
    //   console.log('this.vDataTable.selected', this.vDataTable.selected)
    //   if (this.vDataTable.selected.length > 0) {
    //     await this.asyncForEach(this.vDataTable.selected, async function (x) {
    //       if (x.date_send == null) {
    //         popupDateSendNotNull = '1'
    //       } else {
    //         detailOrderId = detailOrderId + ',' + x.order_id
    //       }
    //     })

    //     if (popupDateSendNotNull === '1') {
    //       this.$swal({type: 'error', title: this.$t('WpLabReceive.pleaseSendLabFirst')})
    //     } else {
    //       this.detail_order_id_for_pdf = detailOrderId
    //       this.name = this.userID
    //       this.requestPDF('S')
    //     }
    //   } else {
    //     this.$swal({type: 'error', title: this.$t('WpLabReceive.pleaseSelectData')})
    //   }
    //   this.dialog.dialogProgress = false
    // },
    async checkPrintRequestSelected () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      try {
        console.log('this.vDataTable.selected', this.vDataTable.selected)
        if (this.vDataTable.selected.length <= 0) {
          this.$swal({
            type: 'error',
            title: this.$t('WpLabReceive.pleaseSelectData')
          })
          return
        }
        const orderIdList = [
          ...new Set(
            this.vDataTable.selected
              .map(x => x.order_id)
              .filter(x => x)
          )
        ].join(',')

        if (!orderIdList) {
          this.$swal({
            type: 'error',
            title: this.$t('WpLabReceive.pleaseSelectData')
          })
          return
        }
        const userPrint = this.userID || 'admin'
        const response = await this.axios.post(process.env.VUE_APP_API + '/reportRequestPDF',
          {
            order_id: orderIdList,
            user_print: userPrint
          },
          {
            responseType: 'blob'
          }
        )

        const file = new Blob([response.data], {
          type: 'application/pdf'
        })
        const fileURL = URL.createObjectURL(file)
        window.open(fileURL)
      } catch (error) {
        console.error(error)
        this.$swal({
          type: 'error',
          title: 'Print request failed'
        })
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    async requestPDF (flag) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      var today = new Date()
      var date = today.getFullYear().toString().substr(-2) + ((today.getMonth() + 1) < 10 ? '0' : '') + (today.getMonth() + 1) + (today.getDate() < 10 ? '0' : '') + today.getDate()
      var time = (today.getHours() < 10 ? '0' : '') + today.getHours() + (today.getMinutes() < 10 ? '0' : '') + today.getMinutes() + (today.getSeconds() < 10 ? '0' : '') + today.getSeconds()
      var dateTimeCurr = date + '_' + time
      await this.axios.post(process.env.VUE_APP_REPORT_PATHO + '/GetRequestReportPdf', {
        val: {
          order_id: this.detail_order_id_for_pdf,
          user_print: this.name
        }
      })
      .then(async response => {
        if (response.data.success === 'true') {
          if (flag === 'D') {
            let soMany = 10
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(new Blob([Base64Binary.decode(response.data.Table[0].pdf)], {type: 'application/pdf; charset=utf-8'}))
            link.setAttribute('download', `${dateTimeCurr}.pdf`)
            link.click()
          } else if (flag === 'S') {
            const url = window.URL.createObjectURL(new Blob([Base64Binary.decode(response.data.Table[0].pdf)], {type: 'application/pdf; charset=utf-8'}))
            this.dialogpdfShow = true
            this.pdfShow = url
          }
        } else {
          if (response.data.message === 'return row from proc 0') {
            this.$swal({type: 'warning', title: 'No Data.'})
          } else {
            this.$swal({type: 'error', title: response.data.message})
          }
        }
      })
      .catch(async e => {
        this.$swal({type: 'error', title: e.message})
      })
      this.dialog.dialogProgress = false
    },
    checkIfDuplicateExists (arrayList) {
      return new Set(arrayList).size !== arrayList.length
    },
    addFile () {
      this.uploadDocumentList.push({ skey: -1, register_skey: -1, upload_skey: -1, image_path: '', filename: '', remark: '', picture_base64: '', urlPreview: '' })
    },
    deleteFile (index) {
      this.uploadDocumentList.splice(index, 1)
    },
    selectLanguage (language) {
    },
    initialize () {
      this.vDataTable.selected = []
      this.vDataTable.editedIndex = -1
      this.vDataTable.editedItem = {
        win_name: '',
        window_comment: ''
      }
      this.vDataTable.defaultItem = {
        win_name: '',
        window_comment: ''
      }
      this.vDataTable2.data = []
    },
    async getProductList (language) {
      await this.axios.post(process.env.VUE_APP_API + '/product/retrieveProductList' + process.env.VUE_APP_DATABASE_TYPE, {
        lang: language
      })
      .then(response => {
        this.productList = response.data.data
      })
      .catch(e => {
        this.$swal({type: 'error', title: e.message})
      })
    },
    async updateRefcode () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waitingSave')
      await this.axios.post(process.env.VUE_APP_API + '/register/updateRefcode' + process.env.VUE_APP_DATABASE_TYPE, {
        idCard: this.idCard
      })
        .then(async response => {
          if (response.data.isSuccess) {
            // this.clearFlag()
            this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
            this.retrieveRegister()
          } else {
            await this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(async e => {
          await this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    closeDialogpdfShow () {
      this.dialogpdfShow = false
    },
    async retrieveUploadDocument (registerSkey) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/register/retrieveUploadDocument' + process.env.VUE_APP_DATABASE_TYPE, {
        register_skey: registerSkey
      })
        .then(async response => {
          this.uploadDocumentList = response.data.data
        })
        .catch(async e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async retrieveFrontUpload (languageID) {
      await this.axios.post(process.env.VUE_APP_API + '/upload/retrieveFrontUpload' + process.env.VUE_APP_DATABASE_TYPE, {
        language_id: languageID
      })
        .then(async response => {
          this.uploadList = response.data.data
        })
        .catch(async e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async retrieveFrontGuarantee (languageID) {
      await this.axios.post(process.env.VUE_APP_API + '/guarantee/retrieveFrontGuarantee' + process.env.VUE_APP_DATABASE_TYPE, {
        language_id: languageID
      })
        .then(async response => {
          this.guaranteeList = response.data.data
        })
        .catch(async e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async retrieveFrontReject (languageID) {
      await this.axios.post(process.env.VUE_APP_API + '/reject/retrieveFrontReject' + process.env.VUE_APP_DATABASE_TYPE, {
        language_id: languageID
      })
        .then(async response => {
          this.rejectList = response.data.data
        })
        .catch(async e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async retrieveFromKey (key) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      await this.axios.post(process.env.VUE_APP_API + '/retrieveFromHN' + process.env.VUE_APP_DATABASE_TYPE, {
        orderSkey: key
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.patient_skey = response.data.data[0].patient_skey // localStorage.getItem('patient_skey')
            this.hn = response.data.data[0].hn
            this.prefix_desc = response.data.data[0].prefix_desc
            this.first_name = response.data.data[0].first_name
            this.middle_name = response.data.data[0].middle_name
            this.last_name = response.data.data[0].last_name
            this.age = response.data.data[0].age
            this.sex = response.data.data[0].sex_desc
            this.dateBrithday = response.data.data[0].birthday
            this.prefix = response.data.data[0].prefix
            this.dateSend = response.data.data[0].send_date
            this.dateCollection = response.data.data[0].collection_date
            this.request_by = response.data.data[0].request_by
            this.current_order_id = response.data.data[0].order_id
            this.current_order_skey = response.data.data[0].order_skey
            // localStorage.setItem('st_patient_skey', response.data.data[0].patient_skey)
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
            .then((result) => {
              if (result) {
                this.dialog.dialogAddEditWindow = false
              }
            })
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async getStatusList () {
      this.axios.post(process.env.VUE_APP_API + '/register/getStatusList' + process.env.VUE_APP_DATABASE_TYPE, {
        IsAll: false
      })
        .then(async response => {
          this.statusList = response.data.data
        })
        .catch(async e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    setUpdateFlag (item) {
      if (item.edit_flag === 0) {
        item.edit_flag = 2
      }
    },
    newSubscribeLanguage (item) {
      this.vDataTable.editedItem = Object.assign({}, item)
      // this.dialogLanguage = true
      this.languageEdit = false
    },
    expandCollapseNode (expand) {
      if (expand) {
        this.vDataTable.expanded = this.vDataTable.data
      } else {
        this.vDataTable.expanded = []
      }
    },
    findCopyHeader (skey) {
      return this.vDataTable.data.find(function (x) {
        return (x.skey === skey)
      })
    },
    findNodeSelectedLanguage (skey) {
      return this.vDataTable.data.find(function (x) {
        return (x.skey === skey)
      }).selectedLanguage
    },
    async retrieveRegister (appName) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      if (this.criteria.ReceivedDateFromTo.length > 0) {
        this.dateSearchFrom = this.criteria.ReceivedDateFromTo[0]
        if (this.criteria.ReceivedDateFromTo.length > 1) {
          this.dateSearchTo = this.criteria.ReceivedDateFromTo[1]
        } else {
          this.dateSearchTo = new Date().toISOString().slice(0, 10)
        }
      }
      await this.axios.post(process.env.VUE_APP_API + '/register/retrieveRegisterAdmin' + process.env.VUE_APP_DATABASE_TYPE, {
        date_from: this.dateSearchFrom,
        date_to: this.dateSearchTo,
        status: this.status,
        firstName: this.firstName,
        lastName: this.lastName,
        idCard: this.idCard,
        tel: this.tel
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTable.data = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async retrieveWPPaymentTypeList () {
      await this.axios.post(process.env.VUE_APP_API + '/register/retrieveWPPaymentTypeList' + process.env.VUE_APP_DATABASE_TYPE, {
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.paymentTypeList = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async retrieveWPProjectList () {
      await this.axios.post(process.env.VUE_APP_API + '/register/retrieveWPProjectList' + process.env.VUE_APP_DATABASE_TYPE, {
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.projectList = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async retrieveRejectReasonList () {
      await this.axios.post(process.env.VUE_APP_API + '/register/retrieveRejectReasonList' + process.env.VUE_APP_DATABASE_TYPE, {
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.rejectReasonList = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async asyncForEach (array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array)
      }
    },
    async ReceiveRequestSelected () {
      this.addReceiveRequestSelected('|' + this.detail_order_skey)
      this.dialog.dialogAddOrder = false
      this.dialog.dialogAddEditWindow = false
    },
    async addReceiveRequestSelected (concatorderskey) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      await this.axios.post(process.env.VUE_APP_API + '/addReceiveRequestSelected' + process.env.VUE_APP_DATABASE_TYPE, {
        order_skey: concatorderskey
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.retrieveLabReceive()
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    // checkReceiveselectedDetail () {
    //   if (this.vDataTable2.selected.length > 0) {
    //     this.$swal({
    //       text: this.$t('ต้องการรับสิ่งส่งตรวจ ?'),
    //       type: 'question',
    //       showCancelButton: true,
    //       confirmButtonColor: '#3085d6',
    //       cancelButtonColor: '#d33',
    //       confirmButtonText: this.$t('yes'),
    //       cancelButtonText: this.$t('no')
    //     }).then((result) => {
    //       if (result) {
    //         this.receiveSelected()
    //       }
    //     })
    //   } else {
    //     this.$swal({type: 'warning', title: this.$t('กรุณาเลือกสิ่งส่งตรวจที่ต้องการรับ')})
    //   }
    // },
    async receiveSelected () {
      // #### ยกเลิก Popup การเลือกประเภทการชำระเงิน และโครงการออก #### //
      // var messageCustom = ''
      // if (this.vDataTable.editedItem.paymentType === '') {
      //   messageCustom = messageCustom + 'กรุณาระบุประเภทการชำระเงิน ' + '<br />'
      // }
      // if (this.vDataTable.editedItem.project === '') {
      //   messageCustom = messageCustom + 'กรุณาระบุโครงการ ' + '<br />'
      // }
      // if (messageCustom) {
      //   this.$swal({type: 'warning', title: messageCustom, showConfirmButton: true, timer: 2500})
      //   return false
      // }
      this.progressMessage = this.$t('waiting')
      var popupDateReceiveNotNull = ''
      var orderItemSkey = ''
      var specimenTypeCd = ''

      await this.asyncForEach(this.vDataTable.selected, async function (x) {
        // this.progressMessage = this.stringFormat(this.$t('SubscribeMaint.progressMessageDelete'), x.OrderItemId)
        // var val = await this.deleteNode(x)
        if (x.status === 'OP' || x.status === 'CA' || x.status === 'RF') {
          orderItemSkey = orderItemSkey + ',' + x.order_item_skey
          specimenTypeCd = specimenTypeCd + ',' + x.specimen_type_cd
        } else {
          popupDateReceiveNotNull = '1'
        }
      })
      // for (const x in del) {
      //   this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
      // }
      // if (popupDateReceiveNotNull === '1') {
      //   this.$swal({type: 'error', title: 'รายการสั่งตรวจที่รับแล้ว ไม่สามารถรับซ้ำได้ กรุณาปฏิเสธสิ่งส่งตรวจเก่าก่อน'})
      // }
      this.receiveOrderItem(this.vDataTable.selected, orderItemSkey, specimenTypeCd)

      this.dialog.dialogReceiveSpecimen = false
    },
    async receiveOrderItem (item, orderItemSkey, specimenTypeCd) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var valRet
        await this.axios.post(process.env.VUE_APP_API + '/receive/receiveOrderItem' + process.env.VUE_APP_DATABASE_TYPE, {
          // data: item,
          order_item_skey_list: orderItemSkey,
          specimen_type_id: item[0].specimen_type_id,
          order_skey: item[0].order_skey,
          order_id: item[0].order_id,
          user_created: localStorage.getItem('username')
        })
          .then(async response => {
            if (response.data.isSuccess) {
              valRet = item
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.retrieveDetailFromOrderID(this.detail_order_id, this.detail_sub_category_skey)
        this.dialog.dialogProgress = false
      }
    },
    // checkCancelReceiveselectedDetail () {
    //   if (this.vDataTable2.selected.length > 0) {
    //     this.$swal({
    //       text: this.$t('ต้องการปฏิเสธสิ่งส่งตรวจ ?'),
    //       type: 'question',
    //       showCancelButton: true,
    //       confirmButtonColor: '#3085d6',
    //       cancelButtonColor: '#d33',
    //       confirmButtonText: this.$t('yes'),
    //       cancelButtonText: this.$t('no')
    //     }).then((result) => {
    //       if (result) {
    //         this.cancelReceiveSelected()
    //       }
    //     })
    //   } else {
    //     this.$swal({type: 'warning', title: this.$t('กรุณาเลือกสิ่งส่งตรวจที่ต้องการปฏิเสธ')})
    //   }
    // },
    async confirmCancelReceive () {
      var messageCustom = ''
      if (this.vDataTable.selectedItem.rejectReason === '') {
        messageCustom = messageCustom + this.$t('WpLabReceive.enterReason') + '<br />'
      }
      if (messageCustom) {
        this.$swal({type: 'warning', title: messageCustom, showConfirmButton: true, timer: 2500})
      } else {
        // await this.asyncForEach(this.vDataTable2.selected, async (x) => {
        //   await this.cancelReceiveOrderItem(x)
        // })
        await this.cancelReceiveOrderItem()
        this.closeDialogRejectSpecimen()
      }
    },
    async cancelReceiveOrderItem (x) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/receive/cancelReceiveOrderItem' + process.env.VUE_APP_DATABASE_TYPE, {
          data: this.vDataTable2.selected,
          reject_reason: this.vDataTable.selectedItem.rejectReason,
          reject_remark: this.vDataTable.selectedItem.rejectRemark || '',
          reject_user: this.vDataTable.selectedItem.rejectUser || '',
          specimen_type_cd: this.vDataTable2.selected.map(item => item.specimen_type_id).join('|'),
          order_item_skey: this.vDataTable2.selected.map(item => item.order_item_skey).join(','),
          user_created: localStorage.getItem('username')
        })
          .then(async response => {
            if (response.data.isSuccess) {
              // await this.sendEmailForRejectSpecimenByItem()
              this.retrieveDetailFromOrderID(this.detail_order_id, this.detail_sub_category_skey)
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    async sendEmailForRejectSpecimenByItem () {
      this.dialog.dialogProgress = true
      await this.axios.post(process.env.VUE_APP_API + '/register/sendEmailForRejectSpecimenByItem', {
        data: this.vDataTable2.selected,
        email: this.userEmail,
        header: this.vDataTable.selectedItem,
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.$swal({type: 'success', title: response.data.reasonText})
            .then((result) => {
              if (result) {
                this.close()
              }
            })
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    // async sendEmailForRejectSpecimen () {
    //   this.dialog.dialogProgress = true
    //   this.vDataTable.selectedItem.email = this.userEmail
    //   await this.axios.post(process.env.VUE_APP_API + '/register/sendEmailForRejectSpecimen',
    //     this.vDataTable.selectedItem
    //   )
    //     .then(response => {
    //       if (response.data.isSuccess) {
    //         this.$swal({type: 'success', title: response.data.reasonText})
    //         .then((result) => {
    //           if (result) {
    //             this.close()
    //           }
    //         })
    //       } else {
    //         this.$swal({type: 'error', title: response.data.reasonText})
    //       }
    //     })
    //     .catch(e => {
    //       this.$swal({type: 'error', title: e.message})
    //     })
    //   this.dialog.dialogProgress = false
    // },
    // ยกเลิก cancel ทั้งแล็บ
    // async cancelReceiveOrder () {
    //   try {
    //     this.dialog.dialogProgress = true
    //     this.progressMessage = this.$t('waiting')
    //     await this.axios.post(process.env.VUE_APP_API + '/cancelReceiveOrder' + process.env.VUE_APP_DATABASE_TYPE, {
    //       order_skey: this.detail_order_skey,
    //     })
    //       .then(async response => {
    //         if (response.data.isSuccess) {
    //           await this.sendEmailForRejectSpecimen()
    //         } else {
    //           await this.$swal({type: 'error', title: response.data.reasonText})
    //         }
    //       })
    //       .catch(async e => {
    //         await this.$swal({type: 'error', title: e.message})
    //       })
    //   } catch (e) {
    //     await this.$swal({type: 'error', title: e.message})
    //   } finally {
    //     this.dialog.dialogProgress = false
    //   }
    // },
    async checkCancelReceiveRequestSelected () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      var del = []
      var valOrderSkey = ''

      await this.asyncForEach(this.vDataTable.selected, async function (x) {
        // this.progressMessage = this.stringFormat(this.$t('SubscribeMaint.progressMessageDelete'), x.OrderItemId)
        // var val = await this.deleteNode(x)
        // var val = await this.deleteOrderItem(x.OrderItemId)
        // localStorage.setItem('dataListItem', localStorage.getItem('dataListItem') + '|' + SelectOrderItemID)
        var val = await this.concatOrderSkey(x.order_skey)
        valOrderSkey = valOrderSkey + '|' + x.order_skey
      }.bind(this))

      this.deleteReceiveRequestSelected(valOrderSkey)
      this.dialog.dialogProgress = false
    },
    async calcelReceiveRequestSelected () {
      this.deleteReceiveRequestSelected('|' + this.detail_order_skey)
      this.dialog.dialogAddOrder = false
      this.dialog.dialogAddEditWindow = false
    },
    async deleteReceiveRequestSelected (concatorderskey) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      await this.axios.post(process.env.VUE_APP_API + '/deleteReceiveRequestSelected' + process.env.VUE_APP_DATABASE_TYPE, {
        order_skey: concatorderskey
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.retrieveLabReceive()
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async deleteRowItemConfirm (item) {
      this.dialog.dialogProgress = true
      this.vDataTable2.editedIndex = this.vDataTable2.data.indexOf(item.OrderItemdesc)
      this.vDataTable2.editedItem = Object.assign({}, item)
      this.$swal({
        text: this.stringFormat('Delete :', item.OrderItemdesc),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          var val = await this.deleteReceiveOrderItem(item.OrderItemId)
          this.dialog.dialogProgress = false
          if (val !== undefined) {
            this.vDataTable2.selected.splice(this.vDataTable2.selected.indexOf(this.vDataTable2.editedItem), 1)
          }
          this.vDataTable2.editedItem = Object.assign({}, this.vDataTable2.defaultItem)
          this.vDataTable2.editedIndex = -1
        }
      })
    },
    async deleteReceiveOrderItem (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var OrderItemId = item
        var valRet
        await this.axios.post(process.env.VUE_APP_API + '/deleteReceiveOrderItem' + process.env.VUE_APP_DATABASE_TYPE, {
          order_skey: this.detail_order_skey,
          OrderItemId: OrderItemId
        })
          .then(async response => {
            if (response.data.isSuccess) {
              // this.vDataTable.data.splice(this.vDataTable.data.indexOf(item), 1)
              // this.$swal({type: 'success', title: response.data.reasonText})
              this.retrieveDetailFromOrderID(this.detail_order_id, this.detail_sub_category_skey)
              valRet = item
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    checkDeleteFile (skey, registerSkey, uploadSkey, ind, imagePath) {
      this.$swal({
        text: this.$t('RegisterMaint.confirmDeleteSelected'),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then((result) => {
        if (result) {
          this.deleteUploadFile(skey, registerSkey, uploadSkey, ind, imagePath)
        }
      })
    },
    async deleteUploadFile (skey, registerSkey, uploadSkey, ind, imagePath) {
      if (skey === -1) {
        this.deleteFile(ind)
        return
      }
      await this.axios.post(process.env.VUE_APP_API + '/register/deleteUploadDocument' + process.env.VUE_APP_DATABASE_TYPE, {
        skey: skey,
        register_skey: registerSkey,
        upload_skey: uploadSkey,
        image_path: imagePath
      })
        .then(async response => {
          this.deleteFile(ind)
          if (response.data.isSuccess) {
            this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
            // this.resetData()
            // this.dialog.dialogPrint = false
            // his.retrieveRegisterPartner() // this.uploadFile()
            this.retrieveUploadDocument(this.vDataTable.editedItem.register_skey)
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(async e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async addSubscribe (name, email, tel, pictureBase64, activeFlag) {
      if (!tel) {
        tel = ''
      }
      if (!pictureBase64) {
        pictureBase64 = ''
      }
      await this.axios.post(process.env.VUE_APP_API + '/register/addSubscribe' + process.env.VUE_APP_DATABASE_TYPE, {
        name: name,
        email: email,
        tel: tel,
        picture_base64: pictureBase64,
        active_flag: activeFlag
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTable.editedItem.skey = response.data.data.skey
            this.vDataTable.data.push(this.vDataTable.editedItem)
            this.retrieveSubscribe()
            this.$swal({type: 'success', title: response.data.reasonText})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async updateSubscribe (skey, name, email, tel, pictureBase64, activeFlag) {
      if (!tel) {
        tel = ''
      }
      if (!pictureBase64) {
        pictureBase64 = ''
      }
      await this.axios.post(process.env.VUE_APP_API + '/register/updateSubscribe' + process.env.VUE_APP_DATABASE_TYPE, {
        skey: skey,
        name: name,
        email: email,
        tel: tel,
        picture_base64: pictureBase64,
        active_flag: activeFlag,
      })
        .then(response => {
          if (response.data.isSuccess) {
            Object.assign(this.vDataTable.data[this.vDataTable.editedIndex], this.vDataTable.editedItem)
            this.retrieveSubscribe()
            this.$swal({type: 'success', title: response.data.reasonText})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    checkDeleteselected () {
      if (this.vDataTable.selected.length > 0) {
        this.$swal({
          text: this.$t('SubscribeMaint.confirmDeleteSelected'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.deleteSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('SubscribeMaint.messageDeleteNotSelected')})
      }
    },
    checkDeleteselectedLanguage (item) {
      if (this.findNodeSelectedLanguage(item.skey).length > 0) {
        this.$swal({
          text: this.$t('SubscribeMaint.confirmSubscribeLanguageDeleteSelected'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.deleteLanguageSelected(item)
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('SubscribeMaint.messagedeleteSubscribeLanguageNotSelected')})
      }
    },
    async deleteSelected () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      var del = []

      await this.utils.asyncForEach(this.vDataTable.selected, async function (x) {
        this.progressMessage = this.stringFormat(this.$t('SubscribeMaint.progressMessageDelete'), x.name_name)
        var val = await this.deleteNode(x)

        if (val !== undefined) {
          del.push(val)
        }
      }.bind(this))
      for (const x in del) {
        this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
      }
      this.dialog.dialogProgress = false
    },
    async deleteLanguageSelected (item) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      var del = []

      await this.utils.asyncForEach(this.findNodeSelectedLanguage(item.skey), async function (x) {
        this.progressMessage = this.stringFormat(this.$t('SubscribeMaint.progressMessageNodeLanguageDelete'), x.name)
        var val = await this.deleteLanguage(x)

        if (val !== undefined) {
          del.push(val)
        }
      }.bind(this))
      for (const x in del) {
        var selectedLanguage = this.findNodeSelectedLanguage(item.skey)
        selectedLanguage.splice(selectedLanguage.indexOf(x), 1)
      }

      this.dialog.dialogProgress = false
    },
    async deleteNode (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var skey = item.skey
        var valRet
        await this.axios.post(process.env.VUE_APP_API + '/register/deleteSubscribe' + process.env.VUE_APP_DATABASE_TYPE, {
          skey: skey
        })
          .then(async response => {
            if (response.data.isSuccess) {
              if (this.vDataTable.data.indexOf(item) >= 0) {
                this.vDataTable.data.splice(this.vDataTable.data.indexOf(item), 1)
              }
              this.$swal({type: 'success', title: response.data.reasonText})
              valRet = item
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    newItem () {
      this.vDataTable.editedItem.active_flag = 'Y'
    },
    editItem (item) {
      this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      this.vDataTable.selectedItem = Object.assign({}, item)
      this.vDataTable.selected.push(Object.assign({}, item))
      this.retrieveFromKey(item.order_skey)
      this.hn = item.hn
      this.detail_order_skey = item.order_skey
      this.detail_order_id = item.order_id
      this.detail_order_lab_skey = item.LaboratorySkey
      this.detail_sub_category_skey = item.sub_category_skey
      this.vDataTable2.selected = [] // clear selected data in dialogAddEditWindow
      this.dialog.dialogAddEditWindow = true
      this.lab_status = item.lab_status
      this.retrieveDetailFromOrderID(item.order_id, item.sub_category_skey)
    },
    async deleteItemConfirm (item) {
      this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      this.vDataTable.editedItem = Object.assign({}, item)
      this.$swal({
        text: this.stringFormat(this.$t('SubscribeMaint.confirmDelete'), item.name),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          var val = await this.deleteNode(item)
          if (val !== undefined) {
            if (this.vDataTable.selected.indexOf(this.vDataTable.editedItem) >= 0) {
              this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(this.vDataTable.editedItem), 1)
            }
          }
          this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
          this.vDataTable.editedIndex = -1
        }
      })
    },
    closeDialogReceiveSpecimen () {
      this.dialog.dialogReceiveSpecimen = false
    },
    closeDialogRejectSpecimen () {
      this.dialog.dialogRejectSpecimen = false
    },
    close () {
      this.dialog.dialogAddEditWindow = false
      this.retrieveLabReceive()
      this.$nextTick(() => {
        this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
        this.vDataTable.editedIndex = -1
      })
    },
    async save () {
      if (this.vDataTable.editedIndex > -1) {
        await this.updateSubscribe(this.vDataTable.editedItem.skey,
          this.vDataTable.editedItem.name,
          this.vDataTable.editedItem.email,
          this.vDataTable.editedItem.tel,
          this.vDataTable.editedItem.picture_base64,
          this.vDataTable.editedItem.active_flag)
      } else {
        await this.addSubscribe(this.vDataTable.editedItem.name,
          this.vDataTable.editedItem.email,
          this.vDataTable.editedItem.tel,
          this.vDataTable.editedItem.picture_base64,
          this.vDataTable.editedItem.active_flag)
      }
      // this.close()
    },
    closeLanguage () {
      this.dialog.dialogLanguage = false
      this.$nextTick(() => {
        this.vDataTable.editedLanguageItem = Object.assign({}, this.vDataTable.defaultLanguageItem)
        this.vDataTable.editedLanguageIndex = -1
      })
    },
    pickFileInsert (image) {
      this.$refs.imageInsert.click()
    },
    handleFileSelectInsert: function (event) {
      var input = event.target
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = (e) => {
          var binaryData = e.target.result
          this.vDataTable.editedItem.tel = input.files[0].name
          this.vDataTable.editedItem.picture_base64 = window.btoa(binaryData)
        }
        reader.readAsBinaryString(input.files[0])
      }
    },
    resetDistrictSubdistrict () {
      // this.$swal({type: 'error', html: this.provinceId})
      this.vDataTable.editedItem.district_id = 0
      this.vDataTable.editedItem.sub_district_id = 0
    },
    resetSubdistrict () {
      this.vDataTable.editedItem.sub_district_id = 0
    },
    setZipcode () {
      let options = this.subDistrictList
      let zip = options.filter(o => o.id === this.vDataTable.editedItem.sub_district_id)
      zipcode = zip[0].zip_code
    },
    async uploadFile () {
      var isSuccess = true
      var msg = ''
      var isSave = false
      var i = 0
      var perCentComplete = 0
      for (i = 0; i < this.uploadDocumentList.length; i++) {
        if (this.uploadDocumentList[i].skey === -1) {
          this.dialog.dialogUpload = true
          this.progressMessage = this.$t('WpLabReceive.uploadingFile') + ' ' + this.uploadDocumentList[i].filename
          let formData = new FormData()
          formData.append('skey', this.uploadDocumentList[i].skey)
          formData.append('register_skey', this.vDataTable.editedItem.register_skey)
          formData.append('upload_skey', this.uploadDocumentList[i].upload_skey)
          formData.append('remark', this.uploadDocumentList[i].remark)
          formData.append('file', this.uploadDocumentList[i].picture_base64)
          await this.axios.post(process.env.VUE_APP_API + '/register/uploadPicture' + process.env.VUE_APP_DATABASE_TYPE, formData,
            {
              headers: {'Content-Type': 'multipart/form-data'},
              onUploadProgress: function (progressEvent) {
                perCentComplete = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
                this.uploadPercentage = perCentComplete
                if (i === this.uploadDocumentList.length && perCentComplete === 100) {
                  isSave = true
                  this.retrieveUploadDocument(this.vDataTable.editedItem.register_skey)
                  this.retrieveRegister()
                  this.dialog.dialogUpload = false
                  this.dialog.dialogAddEditWindow = false
                  // this.retrieveRegisterPartner()
                  this.$swal({type: 'success', title: this.$t('WpLabReceive.uploadSuccess'), showConfirmButton: false, timer: 1500})
                }
              }.bind(this)
            }
          ).then(async response => {
            if (!response.data.isSuccess) {
              msg = msg + response.data.reasonText + '<br>'
            }
          })
          .catch(async e => {
            // this.$swal({type: 'error', title: e.message})
            msg = msg + response.data.reasonText + '<br>'
          })
        }
        perCentComplete = 0
      }
      this.$swal({type: 'success', title: this.successMsg, showConfirmButton: false, timer: 1500})
      this.retrieveUploadDocument(this.vDataTable.editedItem.register_skey)
      this.dialog.dialogUpload = false
      this.dialog.dialogAddEditWindow = false
    },
    Download (pathImage, filename) {
      this.axios.post(process.env.VUE_APP_API + '/register/getFileBase64', {
        path_image: pathImage
      }, {})
        .then(response => {
          if (response.data.isSuccess) {
            const url = window.URL.createObjectURL(new Blob([Base64Binary.decode(response.data.pdf_base64)], {type: 'application/pdf; charset=utf-8'}))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    DownloadZip () {
      var fileName = this.vDataTable.editedItem.first_name + '_' + this.vDataTable.editedItem.last_name + '.zip'
      if (this.vDataTable.editedItem.company_flag === 'Y') {
        fileName = this.vDataTable.editedItem.company_name + '.zip'
      }
      var registerSkey = this.vDataTable.editedItem.register_skey
      this.axios.post(process.env.VUE_APP_API + '/register/getZipFileBase64', {
        file_name: fileName,
        register_skey: registerSkey
      }, {})
        .then(response => {
          if (response.data.isSuccess) {
            const url = window.URL.createObjectURL(new Blob([Base64Binary.decode(response.data.pdf_base64)], {type: 'application/zip; charset=utf-8'}))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    validatePhoneNumber (myTelephone) {
      var ret = true
      if (!myTelephone.match(this.regTelephone)) {
        ret = false
      }
      return ret
    },
    validateIdcard (idCard) {
      var ret = true
      var sum = 0
      var i = 0
      if (!this.IsNumeric(idCard)) {
        ret = false
      } else if (idCard.substring(0, 1) === 0) {
        ret = false
      } else if (idCard.length !== 13) {
        ret = false
      } else {
        for (i = 0, sum = 0; i < 12; i++) {
          sum += parseFloat(idCard.charAt(i)) * (13 - i)
        }
        if ((11 - sum % 11) % 10 !== parseFloat(idCard.charAt(12))) {
          ret = false
        } else {
          ret = true
        }
      }
      return ret
    },
    IsNumeric (id) {
      return !isNaN(parseFloat(id)) && isFinite(id)
    },
    validateMail (myEmail) {
      var ret = true
      if (!this.regEmail.test(myEmail)) {
        ret = false
      }
      return ret
    },
    openDialogReceiveSpecimen () {
      console.log(this.vDataTable.selectedItem)
      const item = this.vDataTable.selectedItem
      if (item.payment_code === 'TRN' && ['CA', 'IP', 'OP'].includes(item.invoice_code)) {
        this.$swal({ type: 'warning', title: this.$t('WpLabReceive.pleaseGoPayment') })
      } else {
        if (this.vDataTable.selected.length > 0) {
          let countReceiveItem = 0
          this.vDataTable2.selected.forEach((x) => {
            if (x.status === 'CO') {
              countReceiveItem += 1
            }
            // if (x.status === 'RF') {
            //   countReceiveItem += 1
            // }
          })
          if (countReceiveItem > 0) {
            this.dialog.dialogProgress = false
            this.$swal({type: 'error', title: this.$t('WpLabReceive.warningReceiveAgain')})
            return
          }
          this.$swal({
            text: this.$t('WpLabReceive.confirmReceiveSpecimenTitle'),
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes'),
            cancelButtonText: this.$t('no')
          }).then((result) => {
            if (result) {
              this.receiveSelected()
            }
          })
        } else {
          this.$swal({type: 'warning', title: this.$t('WpLabReceive.pleaseSelectSpecimenToReceive')})
        }
      }
    },
    openDialogRejectSpecimen () {
      if (this.vDataTable2.selected.length === 0) {
        this.$swal({ type: 'warning', title: this.$t('WpLabReceive.pleaseSelectReject') })
        return
      }
      if (this.lab_status === 'FIRSTAPPROVE' || this.lab_status === 'LASTAPPROVE') {
        this.$swal({ type: 'warning', title: this.$t('WpLabReceive.pleaseCancalApproveFirst') })
        return
      }
      const hasRejected = this.vDataTable2.selected.some(item => item.status === 'RF')
      if (hasRejected) {
        this.dialog.dialogProgress = false
        this.$swal({ type: 'error', title: this.$t('WpLabReceive.warningRejectAgain') })
        return
      }
      if (this.vDataTable2.selected.length === 1) {
        this.vDataTable.selectedItem.rejectReason = ''
      }
      this.dialog.dialogRejectSpecimen = true
    },
    async openDialogreturnSpecimen () {
      if (this.vDataTable2.selected.length > 0) {
        this.$swal({
          text: this.$t('WpLabReceive.confirmReturnSpecimenTitle'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.returnSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('WpLabReceive.pleaseSelectSpecimenToReturn')})
      }
    },
    async returnSelected () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      var hasOPStatus = false
      var del = []
      var orderItemSkey = ''
      var errorMessage = ''
      if (this.lab_status === 'FIRSTAPPROVE' || this.lab_status === 'LASTAPPROVE') {
        this.$swal({ type: 'warning', title: this.$t('WpLabReceive.pleaseCancalApproveFirst') })
      } else {
        await this.asyncForEach(this.vDataTable2.selected, async (x) => {
          if (x.status === 'OP' || x.status === 'CA') {
            hasOPStatus = true
            errorMessage = this.$t('WpLabReceive.errorReturnSpecimen')
          }
        })
        if (!hasOPStatus) {
          await this.asyncForEach(this.vDataTable2.selected, async function (x) {
            orderItemSkey = orderItemSkey + ',' + x.order_item_skey
          })
          await this.returnOrderItem(this.vDataTable2.selected, orderItemSkey)
        } else {
          this.$swal({type: 'error', title: errorMessage})
        }
      }
      this.dialog.dialogProgress = false
    },
    async returnOrderItem (item, orderItemSkey) {
      try {
        if (item[0].pmt_type === 'CRD' && item[0].accounting_invoice_no !== null) {
          this.$swal({ type: 'error', title: this.$t('WpLabReceive.pleaseCancalApproveFirst') })
          return
        } else {
          this.dialog.dialogProgress = true
          this.progressMessage = this.$t('waiting')
          var valRet
          await this.axios.post(process.env.VUE_APP_API + '/receive/returnOrderItem' + process.env.VUE_APP_DATABASE_TYPE, {
            order_item_skey_list: orderItemSkey,
            specimen_type_id: item[0].specimen_type_id,
            order_skey: item[0].order_skey,
            order_id: item[0].order_id,
            user_created: localStorage.getItem('username')
          })
            .then(async response => {
              if (response.data.isSuccess) {
                valRet = item
              } else {
                await this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
            .catch(async e => {
              await this.$swal({type: 'error', title: e.message})
            })
          return valRet
        }
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.retrieveDetailFromOrderID(this.detail_order_id, this.detail_sub_category_skey)
        this.dialog.dialogProgress = false
      }
    },
    async openDialogCancelSpecimen () {
      if (this.vDataTable2.selected.length > 0) {
        this.$swal({
          text: this.$t('WpLabReceive.confirmCancelspecimenTitle'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.cancelSpecimenSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('WpLabReceive.pleaseSelectSpecimenToReturn')})
      }
    },
    async cancelSpecimenSelected () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      var hasOPStatus = false
      var del = []
      var orderItemSkey = ''
      if (this.lab_status === 'FIRSTAPPROVE' || this.lab_status === 'LASTAPPROVE') {
        this.$swal({type: 'warning', title: this.$t('WpLabReceive.pleaseCancalApproveFirst')})
      } else {
        await this.asyncForEach(this.vDataTable2.selected, async (x) => {
          if (x.status === 'CA') {
            hasOPStatus = true
          }
        })
        if (!hasOPStatus) {
          await this.asyncForEach(this.vDataTable2.selected, async function (x) {
            orderItemSkey = orderItemSkey + ',' + x.order_item_skey
          })
          await this.cancelOrderItem(this.vDataTable2.selected, orderItemSkey)
        } else {
          this.$swal({type: 'error', title: this.$t('WpLabReceive.errorCancelSpecimenThatAlreadyCancel')})
        }
      }
      this.dialog.dialogProgress = false
    },
    async cancelOrderItem (item, orderItemSkey) {
      try {
        // if (item[0].pmt_type === 'CRD' && item[0].accounting_invoice_no !== null) {
        //   this.$swal({ type: 'error', title: this.$t('WpLabReceive.returnInvoidError') })
        //   return
        // } else {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var valRet
        await this.axios.post(process.env.VUE_APP_API + '/receive/cancelOrderItem' + process.env.VUE_APP_DATABASE_TYPE, {
          order_item_skey_list: orderItemSkey,
          specimen_type_id: item[0].specimen_type_id,
          order_skey: item[0].order_skey,
          order_id: item[0].order_id,
          user_created: localStorage.getItem('username')
        })
          .then(async response => {
            if (response.data.isSuccess) {
              valRet = item
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
        // }
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.retrieveDetailFromOrderID(this.detail_order_id, this.detail_sub_category_skey)
        this.dialog.dialogProgress = false
      }
    },
    isNullOrWhiteSpace (value) {
      return value === null || value === undefined || value.trim() === ''
    },
    async printSpecimenSticker (flag) {
      var messageCustom = ''
      if (this.vDataTable2.selected.length < 1) {
        messageCustom = 'Please select item.'
        this.$swal({type: 'error', html: messageCustom})
        return
      }
      const hasNull = this.vDataTable2.selected.some(item => item.status_desc === '')
      if (hasNull) {
        messageCustom = 'Some item not receive.'
        this.$swal({type: 'error', html: messageCustom})
        return
      }
      const ids = this.vDataTable2.selected.map(item => item.OrderItemId).join(',')
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('Now Printing waiting.......')
      var today = new Date()
      var date = today.getFullYear().toString().substr(-2) + ((today.getMonth() + 1) < 10 ? '0' : '') + (today.getMonth() + 1) + (today.getDate() < 10 ? '0' : '') + today.getDate()
      var time = (today.getHours() < 10 ? '0' : '') + today.getHours() + (today.getMinutes() < 10 ? '0' : '') + today.getMinutes() + (today.getSeconds() < 10 ? '0' : '') + today.getSeconds()
      var dateTimeCurr = date + '_' + time
      console.log(process.env.VUE_APP_REPORT_PATHO + '/GetSpecimenBarcodeReportPdf', 'WCF URL')
      await this.axios.post(process.env.VUE_APP_REPORT_PATHO + '/GetSpecimenBarcodeReportPdf', {
        val: {
          specimen_type_id: this.vDataTable2.selected[0].specimen_type_id,
        }
      })
      .then(async response => {
        if (response.data.success === 'true') {
          if (flag === 'D') {
            let soMany = 10
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(new Blob([Base64Binary.decode(response.data.Table[0].pdf)], {type: 'application/pdf; charset=utf-8'}))
            link.setAttribute('download', `${dateTimeCurr}.pdf`)
            link.click()
          } else if (flag === 'S') {
            const url = window.URL.createObjectURL(new Blob([Base64Binary.decode(response.data.Table[0].pdf)], {type: 'application/pdf; charset=utf-8'}))
            this.dialogpdfShow = true
            this.pdfShow = url
            this.autoPrintPdf()
            await this.printToServer(response.data.Table[0].pdf)
          }
        } else {
          if (response.data.message === 'return row from proc 0') {
            this.$swal({type: 'warning', title: 'No Data.'})
          } else {
            this.$swal({type: 'error', title: response.data.message})
          }
        }
      })
      .catch(async e => {
        this.$swal({type: 'error', title: e.message})
      })
      this.dialog.dialogProgress = false
    },
    autoPrintPdf () {
      // Wait until the iframe has loaded the PDF
      // const iframe = this.$refs.pdfIframe
      // iframe.onload = () => {
      //   iframe.contentWindow.print() // Trigger print dialog
      // }
      console.log('auto')
      const iframe = this.$refs.pdfIframe
      if (iframe) {
        // Wait for a short delay to ensure the iframe is ready
        setTimeout(() => {
          iframe.contentWindow.print() // Trigger print dialog
        }, 500) // Adjust the timeout value (500ms) as necessary
      }
    },
    async printToServer (pdfBase64) {
      try {
        console.log('print')
        const printerName = 'PCL6 V4 Driver ขาวดำ ชั้น3'
        // const printerName = 'RICOH ชั้น 3 ip14'

        const response = await this.axios.post(process.env.VUE_APP_API + '/printPdf' + process.env.VUE_APP_DATABASE_TYPE, {
          pdfBase64: pdfBase64,
          printerName: printerName
        })
        if (response.data.message === 'Print job sent successfully') {
          console.log('PDF sent to printer successfully.')
        } else {
          console.error('Error sending print job:', response.data.message)
        }
      } catch (error) {
        console.error('Error in printing:', error)
      }
    },
    async viewSpecimenStatusHist (item) {
      console.log(item)
      this.dialog.dialogProgress = true
      this.dialog.dialogStatusHist = true
      // vDataTableStatusHist
      await this.axios.post(process.env.VUE_APP_API + '/receive/retrieveSpecimenStatusHist' + process.env.VUE_APP_DATABASE_TYPE, {
        order_skey: item.order_skey,
        order_item_skey: item.order_item_skey
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTableStatusHist.data = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async checkResentGateway () {
      this.dialog.dialogProgress = true
      if (this.vDataTable.selected.length > 0) {
        this.$swal({
          text: 'ต้องการ Resent ?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.resentGatewaySelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('WpLabReceive.pleaseSelectSpecimenToResent')})
      }
      this.dialog.dialogProgress = false
    },
    async resentGatewaySelected () {
      var valOrderSkey = ''
      await this.asyncForEach(this.vDataTable.selected, async function (x) {
        valOrderSkey = valOrderSkey + '|' + x.order_skey
      })
      console.log(valOrderSkey)
      await this.axios.post(process.env.VUE_APP_API + '/receive/resentGateway' + process.env.VUE_APP_DATABASE_TYPE, {
        order_skey: valOrderSkey
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.$swal({type: 'success', title: this.$t('WplabReceive.resentGatewaySuccess')})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    viewRemark (item) {
      this.dialog.dialogviewRemark = true
      this.itemRemark = item.remark
    },
    closeViewRemark () {
      this.dialog.dialogviewRemark = false
    },
    async receiveSpecimenMSSQL () {
      try {
        if (!this.vDataTable.selected || this.vDataTable.selected.length < 1) {
          this.$swal({
            type: 'warning',
            title: 'Please select specimen.'
          })
          return
        }
        const confirm = await this.$swal({
          type: 'warning',
          title: 'Confirm receive specimen?',
          text: `Selected ${this.vDataTable.selected.length} item(s)`,
          showCancelButton: true,
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel'
        })
        const isConfirmed = confirm.value || confirm.isConfirmed || confirm === true
        if (!isConfirmed) {
          return
        }
        const items = []
        await this.asyncForEach(this.vDataTable.selected, async function (x) {
          items.push({
            test_item_skey: x.order_skey,
            specimen_type_id: x.specimen_type_id,
            routing_seq: '30',
            status: 'CO',
            remark: '',
            reject_reason: '',
            order_id: x.order_id
          })
        })
        await this.axios.post(process.env.VUE_APP_API + '/receive/updateReceiveSpecimenMSSQL', {
          items: items
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.$swal({
                type: 'success',
                title: response.data.reasonText
              })
              this.vDataTable.selected = []
              this.retrieveLabReceive()
            } else {
              this.$swal({
                type: 'error',
                title: response.data.reasonText
              })
            }
          })
          .catch(e => {
            this.$swal({
              type: 'error',
              title: e.message
            })
          })
      } catch (e) {
        this.$swal({
          type: 'error',
          title: e.message
        })
      }
    }
  },
}
</script>
<style scoped>
.style-1 {
  color: rgb(215, 44, 44);
}
.style-2 {
  color: rgb(114,114,67);
}
.sticky-table-footer td {
  font-weight: bold;
  position: sticky;
  bottom: 0;
  background-color: #f8f8f8;
  border-top: thin solid rgba(0,0,0,.12);
}
.input__label {
  color: rgb(54, 54, 54);
}
.my-text-style >>> .v-text-field__slot input {
  background: rgb(255, 206, 215);
}
.my-select-style >>> .v-text-field__slot select {
  background: rgb(255, 206, 215);
}
a { text-decoration: none; }

.v-text-field.v-input--dense {
  font-weight: bold;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  font-weight: normal !important; /* Ensures label is not bold */
}
</style>
